/**
 * Module to generate, update and otherwise service functions of parametric filters
 * @class ParametricFilter
 * @memberof EBContext.modules
 */
/* jshint esversion: 6 */
EBContext.modules.ParametricFilter = function (options) {
	const self = this;
	const generateSliderStyles = function (filtrtyp, filterConfig){
		if(!filtrtyp) return '';
		let filterStyle = [];
		if(filterConfig._bar_color){
			filterStyle.push('.irs-bar,.irs-handle>i:first-child{background-color:' + filterConfig._bar_color + '}');
		}
		if(filterConfig._label_color){
			filterStyle.push('.irs-from,.irs-to,.irs-single{background-color:' + filterConfig._label_color + '}');
			filterStyle.push('.irs-from:before,.irs-to:before,.irs-single:before{border-top-color:' + filterConfig._label_color + '}');
		}
		self.filterStyles['c_' + filtrtyp] = filterStyle;
		return 'c_' + filtrtyp;
	}
	const clearFilter = (e,el,vars,params)=>{
		let filter;
		if(el instanceof HTMLElement){
			filter = self.filters[el.getAttribute('data-filter')];
		} else {
			filter = self.filters[el];
		}
		if(!filter) return;
		let filterOptions = self.getFilterOptions(filter);
		filterOptions.fnClear(filter.oid);
		filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
		self.submit();
	};

	// Define the default options (to be possibly extended via init function)
	this.options = EBContext.utils.extendObj(false, {
		filterWrapId: 'filterWrap',
		activeWrapId: 'activeFilters',
		priceWrapId: 'priceFilterWrap',
		extendedFilterId: 'extendedFilter',
		filterRelocated: false,
		reloadBlock: 'page',
		resultPageName: 'Result',
		resultPagePath: 'produkty/',
		resultBlockName: 'page',
		visibleItemsCount: 12,
		priceWithVAT: true,
		showQuantity: false,
		useDefault: false,
		alwaysOpen: false,
		collapsibleFilters: false,
		popupFilter: false,
		// appearance: {
		// 	filter: {
		// 		collapsible: true,
		// 		defaultOpen: false
		// 	},
		// 	parameters: {
		// 		collapsible: true,
		// 		defaultOpen: false,
		// 		appearance: 'list' //['tabs','list','carousel']
		// 	},
		// 	values: {
		// 		collapsible: true,
		// 		defaultOpen: false,
		// 		showFirst: 0
		// 	}
		// }, 
		getLoader: fwEl=>{
			return new EBContext.modules.Loader({
				parentElement: fwEl,
				loaderClass: 'fas fa-fw fa-spinner fa-spin',
				loaderType: 'overlay',
				prependLoader: false,
				disableParentElement: false,
				independent: false,
				loaderIcon: {
					icon: 'spinner',
					animation: 'spin'
				}
			});
		},
		debug: true,
		paramsTypes: {
			FLOAT: {
				fnParseValue: function (value) {
					let parsedVal = (!value ? value : parseFloat(value.toString().replace(/,/g, '.')));
					return (typeof parsedVal === 'number' ? parsedVal : null);
				},
				filterTypes: {
					CHECKBOX: {
						fnStringify: function (filter) {
							let i, valStr, koef, val, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val = filter.values[i].value;
									values.push((val ? val * koef : val).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					RADIO: {
						fnStringify: function (filter) {
							let i, valStr, koef, val, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val = filter.values[i].value;
									values.push((val ? val * koef : val).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					SELECT: {
						fnStringify: function (filter) {
							let i, valStr, koef, val, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val = filter.values[i].value;
									values.push((val ? val * koef : val).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					MULTI_SELECT_SEARCH: {
						fnStringify: function (filter) {
							let i, valStr, koef, val, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val = filter.values[i].value;
									values.push((val ? val * koef : val).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					NUMBER_INPUTS: {},
					SLIDER_INPUTS: {},
					SLIDER_STEPS: {}
				}
			},
			RANGE: {
				defaultFilterType: 'NUMBER_INPUTS',
				fnParseValue: function (value) {
					if (value !== null) value = parseFloat(value.toString().replace(/,/g, '.'));
					return (typeof value === 'number' ? value : null);
				},
				filterTypes: {
					CHECKBOX: {
						fnStringify: function (filter) {
							let i, valStr, koef, val1, val2, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val1 = filter.values[i].value;
									val2 = filter.values[i].value2;
									values.push((val1 ? val1*koef : val1).toString().replace(/\./g, ',') + '~' + (val2 ? val2*koef : val2).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					RADIO: {
						fnStringify: function (filter) {
							let i, valStr, koef, val1, val2, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val1 = filter.values[i].value;
									val2 = filter.values[i].value2;
									values.push((val1 ? val1 * koef : val1).toString().replace(/\./g, ',') + '~' + (val2 ? val2 * koef : val2).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					SELECT: {
						fnStringify: function (filter) {
							let i, valStr, koef, val1, val2, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val1 = filter.values[i].value;
									val2 = filter.values[i].value2;
									values.push((val1 ? val1 * koef : val1).toString().replace(/\./g, ',') + '~' + (val2 ? val2 * koef : val2).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					MULTI_SELECT_SEARCH: {
						fnStringify: function (filter) {
							let i, valStr, koef, val1, val2, values = [];
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected) {
									koef = filter.values[i].koef || 1;
									val1 = filter.values[i].value;
									val2 = filter.values[i].value2;
									values.push((val1 ? val1 * koef : val1).toString().replace(/\./g, ',') + '~' + (val2 ? val2 * koef : val2).toString().replace(/\./g, ','));
								}
							}
							valStr = values.join(';');
							if (valStr !== '') valStr = '@@@' + valStr;
							return filter.oid + ':::' + filter.type + ':::' + '@@@' + valStr + '###';
						}
					},
					NUMBER_INPUTS: {},
					SLIDER_INPUTS: {},
					SLIDER_STEPS: {}
				}
			},
			ENUM: {
				valueProperty: 'oid',
				filterTypes: {
					CHECKBOX: {},
					RADIO: {},
					SELECT: {},
					MULTI_SELECT_SEARCH: {}
				}
			},
			BOOLEAN: {
				defaultFilterType: 'RADIO',
				filterTypes: {
					RADIO: {},
					SELECT: {}
				},
				fnChange: function (oid, value) {
					let i, changed = false;
					for (i = 0; i < self.filters[oid].values.length; i++) {
						if (self.filters[oid].values[i].value == value) {
							if(!self.filters[oid].values[i].selected) changed = true;
							self.filters[oid].values[i].selected = true;
						} else {
							if(self.filters[oid].values[i].selected) changed = true;
							self.filters[oid].values[i].selected = false;
						}
					}
					return changed;
				},
				fnUpdateFilterValues: function (filter, scope) {
					filter.selected = false;
					scope = scope || document;
					let i, radioEl, labelEl;
					for (i = 0; i < filter.values.length; i++) {
						radioEl = scope.querySelector('#' + self.getValId(filter.oid, filter.values[i].value));
						if (radioEl instanceof HTMLInputElement) {
							radioEl.checked = filter.values[i].selected;
							radioEl.disabled = filter.values[i].disabled;

							labelEl = scope.querySelector('label[for="' + self.getValId(filter.oid, filter.values[i].value) + '"]');
							if (labelEl instanceof HTMLElement) {
								labelEl.innerText = filter.values[i].name + (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
								if(radioEl.disabled){
									labelEl.classList.add('text-muted');
								 } else {
									labelEl.classList.remove('text-muted');
								 }
							}
						}
						filter.selected = filter.selected || (filter.values[i].value !=='' && filter.values[i].selected);
					}
				},
				fnStringify: function (filter) {
					let i, value = '';
					for (i = 0; i < filter.values.length; i++) {
						if (filter.values[i].selected) {
							value = filter.values[i].value;
							break;
						}
					}
					return filter.oid + ':::' + filter.type + ':::' + value + '###';
				}
			},
			COLOR: {
				filterTypes: {
					CHECKBOX: {
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter);
							let filterDOM = EBContext.utils.template('<!--#filterWrapEl-->', {
								filterWrapEl: '<div class="clearfix"><!--#checkboxWrapEl;~:filter.values--></div>',
								checkboxWrapEl: '<div class="checkboxWrap my-1 me-2 float-start"><!--#checkboxEl--><!--#labelEl--></div>',
								checkboxEl: '<input type="checkbox" id="<!--@getValId-->" style="visibility:hidden;width:1rem" data-filter="<!--~filter.oid-->" value="<!--@getValValue-->"<!--!change@onCheckedChange-->>',
								labelEl: '<label for="<!--@getValId-->" class="colorBox" style="width:1rem;height:1rem;display:inline-block;margin-left:-1rem"></label>'
							}, {
								filter: filter,
								getValId: val=>self.getValId(filter.oid, val[filterOptions.valueProperty]),
								getValValue: val=>val[filterOptions.valueProperty],
								onCheckedChange: (e,el,vars)=>(fnChange(el.getAttribute('data-filter'), el.value, el.checked) && self.submit())
							})[0];
							
						    filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let i, checkboxEl, colorBox;
							for (i = 0; i < filter.values.length; i++) {
								checkboxEl = scope.querySelector('#' + self.getValId(filter.oid, filter.values[i].value));
								if (checkboxEl instanceof HTMLInputElement) {
									checkboxEl.checked = filter.values[i].selected;
									checkboxEl.disabled = filter.values[i].disabled;

									colorBox = scope.querySelector('[for="' + self.getValId(filter.oid, filter.values[i].value) + '"]');
									if (colorBox instanceof HTMLElement) {
										colorBox.style.background = (filter.values[i].disabled ? '#f2f2f2' : '#' + filter.values[i].value.toString().replace(/#/g, ''));
									}
									filter.selected = filter.selected || filter.values[i].selected;
								}
							}
						}
					},
					RADIO: {
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter);
							let filterDOM = EBContext.utils.template('<!--#filterWrapEl-->', {
								filterWrapEl: '<div class="clearfix"><!--#radioWrapEl;~:filter.values--></div>',
								radioWrapEl: '<div class="radioWrap my-1 me-2 float-start"><!--#radioEl--><!--#labelEl--></div>',
								radioEl: '<input type="radio" name="filter_<!--~filter.oid-->" id="<!--@getValId-->" style="visibility:hidden;width:1rem" data-filter="<!--~filter.oid-->" value="<!--@getValValue-->"<!--!change@onCheckedChange-->>',
								labelEl: '<label for="<!--@getValId-->" class="colorBox" style="width:1rem;height:1rem;display:inline-block;margin-left:-1rem"></label>'
							}, {
								filter: filter,
								getValId: val=>self.getValId(filter.oid, val[filterOptions.valueProperty]),
								getValValue: val=>val[filterOptions.valueProperty],
								onCheckedChange: (e,el,vars)=>(fnChange(el.getAttribute('data-filter'), el.value, el.checked) && self.submit())
							})[0];
							
						    filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let i, radioEl, colorBox;
							for (i = 0; i < filter.values.length; i++) {
								radioEl = scope.querySelector('#' - self.getValId(filter.oid, filter.values[i].value));
								if (radioEl instanceof HTMLInputElement) {
									radioEl.checked = filter.values[i].selected;
									radioEl.disabled = filter.values[i].disabled;

									colorBox = scope.querySelector('[for="' + self.getValId(filter.oid, filter.values[i].value) + '"]');
									if (colorBox instanceof HTMLElement) {
										colorBox.style.outline = (filter.values[i].selected ? '2px solid #333' : '');
										colorBox.style.background = (filter.values[i].disabled ? '#f2f2f2' : '#' + filter.values[i].value);
										filter.selected = filter.selected || filter.values[i].selected;
									}
								}
							}
						}
					},
					SELECT: {
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter)
							let filterDOM = EBContext.utils.template('<div><!--#selectEl--></div>', {
								selectEl: '<select class="form-control" id="filter_<!--~filter.oid-->" name="filter_<!--~filter.oid-->" aria-label="<!--~filter.name-->" data-filter="<!--~filter.oid-->"<!--!change@onChange-->><!--#optionEl;~filter.values--></select>',
								optionEl: '<option id="<!--@getValId-->" value="<!--$value-->"></option>'																
							}, {
								filter: filter,
								fnChange: fnChange,
								filterOptions: filterOptions,
								getValId: val=>self.getValId(filter.oid, val[filterOptions.valueProperty]),
								onChange: (e,el,vars)=>(fnChange(el.getAttribute('data-filter'), el.value, true) && self.submit())
							})[0];
							
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let selectEl = scope.querySelector('#filter_' + filter.oid),
							i, optionEl;
							for (i = 0; i < filter.values.length; i++) {
								optionEl = scope.querySelector('#' + self.getValId(filter.oid, filter.values[i].value));
								if (optionEl instanceof HTMLOptionElement) {
									optionEl.disabled = filter.values[i].disabled;
									optionEl.style.background = (filter.values[i].disabled ? '#f2f2f2' : '#' + (filter.values[i].value ? filter.values[i].value : 'FFF'));
									optionEl.innerText = (
										(filter.values[i].name ? filter.values[i].name : '') +
										(filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '')
									);
									filter.selected = filter.selected || filter.values[i].selected;
								}
								if (filter.values[i].selected) {
									selectEl.value = filter.values[i].value;
									selectEl.style.background = (filter.disabled ? '#f2f2f2' : '#' + filter.values[i].value);
								}
							}
						}
					}
				},
				fnGenerateActive: function (filter) {
					let filterOptions = self.getFilterOptions(filter),
						activeWrapEl = document.createElement('div'),
						i, valueWrapEl, colorBox, rmBtn;
					self.filters[filter.oid].active = false;
					
					for (i = 0; i < filter.values.length; i++) {
						if (filter.values[i].selected && (filter.values[i].value || typeof filter.values[i].value === 'number')) {
							valueWrapEl = document.createElement('div');
							valueWrapEl.className = 'valueWrap';
							colorBox = document.createElement('div');
							colorBox.className = 'colorBox';
							colorBox.style.background = '#' + filter.values[i].value.toString().replace(/#/g, '');
							valueWrapEl.append(colorBox);
							rmBtn = document.createElement('button');
							rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
							rmBtn.type = 'button';
							rmBtn.className = 'px-2';
							rmBtn.setAttribute('data-filter', filter.oid);
							rmBtn.setAttribute('data-value', filter.values[i][filterOptions.valueProperty]);
							rmBtn.addEventListener('click', function () {
								let filter = self.filters[this.getAttribute('data-filter')];
								let filterOptions = self.getFilterOptions(filter);
								if(filterOptions.fnChange(filter.oid, this.getAttribute('data-value'), false)){
									filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
									self.submit();
								}
							});
							valueWrapEl.appendChild(rmBtn);
							activeWrapEl.appendChild(valueWrapEl);
						}
					}
					if (activeWrapEl.children.length > 0) {
						activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
							label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
							clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
						}, {
							filter: filter,
							clearFilter: clearFilter
						})[0]);
						self.filters[filter.oid].active = true;
						return activeWrapEl;
					}
					return false;
				}
			},
			DEFAULT: {
				valueProperty: 'value',
				defaultFilterType: 'CHECKBOX',
				config: {
					_multiUnitActive: true
				},
				filterTypes: {
					CHECKBOX: {
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter);
							let filterDOM = EBContext.utils.template('<!--#filterContainerEl-->', {
								filterContainerEl: '<div class="container-fluid px-3"><!--#filterWrapEl--><!--@useShowMore--></div>',
								filterWrapEl: '<div class="row row-cols-1 row-cols-sm-2 row-cols-xl-4 box-visible"><!--@renderVisibleItems--></div>',
								boxMoreEl: '<div class="row row-cols-1 row-cols-sm-2 row-cols-xl-4 ml-0 box-more d-none"><!--@renderInvisibleItems--></div>',
								showMoreEl: '<button type="button" class="show-more btn btn-sm btn-primary w-100 mt-1" id="more_<!--~filter.oid-->"></button>',
								checkboxWrapEl: '<div class="col checkboxWrap form-check flex-grow-1" style="min-width:200px"><!--#checkboxEl--><!--#labelEl--></div>',
								flexFiller: '<div class="col checkboxWrap form-check flex-grow-1" style="min-width:200px;height: 0;min-height: 0;"></div>',
								checkboxEl: '<input type="checkbox" id="<!--@getValId-->" class="form-check-input me-2" data-filter="<!--~filter.oid-->" value="<!--@getValValue-->"<!--!change@onCheckedChange-->>',
								labelEl: '<label for="<!--@getValId-->" class="form-check-label w-100"></label>'																
							}, {
								filter: filter,
								fnChange: fnChange,
								filterOptions: filterOptions,
								useShowMore: vars=>(vars.filter.values.length > self.options.visibleItemsCount ? '<!--#boxMoreEl--><!--#showMoreEl-->' : ''),
								renderVisibleItems: vars=>'<!--#checkboxWrapEl;$filter.values[:' + self.options.visibleItemsCount + ']-->'+(vars.filter.values.length<self.options.visibleItemsCount?'<!--#flexFiller;[:2]-->':''),
								renderInvisibleItems: vars=>'<!--#checkboxWrapEl;$filter.values[' + self.options.visibleItemsCount + ']--><!--#flexFiller;[:2]-->',
								getValId: val=>self.getValId(filter.oid, val[filterOptions.valueProperty]),
								getValValue: val=>val[filterOptions.valueProperty],
								onCheckedChange: (e,el,vars)=>(fnChange(el.getAttribute('data-filter'), el.value, el.checked) && self.submit())
							})[0];
							
						    filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let filterOptions = self.getFilterOptions(filter),
								i, checkboxEl, labelEl, textWrap, unit, val1, val2;
							for (i = 0; i < filter.values.length; i++) {
								checkboxEl = scope.querySelector('#' + self.getValId(filter.oid, filter.values[i][filterOptions.valueProperty]));
								if (checkboxEl instanceof HTMLInputElement) {
									checkboxEl.checked = filter.values[i].selected;
									checkboxEl.disabled = filter.values[i].disabled;
									filter.selected = filter.selected || filter.values[i].selected;
								}
								labelEl = scope.querySelector('[for="' + self.getValId(filter.oid, filter.values[i][filterOptions.valueProperty]) + '"]');
								if (labelEl instanceof HTMLElement) {
									textWrap = document.createElement('div');
									textWrap.className = 'text-truncate';
									unit = filter.values[i].unit || filter.unit;
									val1 = filter.values[i][filterOptions.valueProperty];
									val2 = filter.values[i].value2;
									textWrap.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
										+ (val2 ? '~' + val2 : '')
										+ (unit && (val1 || typeof val1 === 'number') ? ' ' + unit : '')
										+ (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
									textWrap.setAttribute('title', textWrap.innerText);
									labelEl.innerHTML = '';
									labelEl.appendChild(textWrap); 
									if(checkboxEl.disabled){
										labelEl.classList.add('text-muted');
									} else {
										 labelEl.classList.remove('text-muted');
									}
								}
							}
						}
					},
					RADIO: {
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter);
							let filterDOM = EBContext.utils.template('<!--#filterContainerEl-->', {
								filterContainerEl: '<div class="container-fluid px-3"><!--#filterWrapEl--><!--@useShowMore--></div>',
								filterWrapEl: '<div class="row row-cols-1 row-cols-sm-2 row-cols-xl-4 box-visible"><!--@renderVisibleItems--></div>',
								boxMoreEl: '<div class="row row-cols-1 row-cols-sm-2 row-cols-xl-4 ml-0 box-more d-none"><!--@renderInvisibleItems--></div>',
								showMoreEl: '<button type="button" class="show-more btn btn-sm btn-primary w-100 mt-1" id="more_<!--~filter.oid-->"></button>',
								radioWrapEl: '<div class="col checkboxWrap form-check flex-grow-1" style="min-width:200px"><!--#radioEl--><!--#labelEl--></div>',
								flexFiller: '<div class="col checkboxWrap form-check flex-grow-1" style="min-width:200px;height: 0;min-height: 0;"></div>',
								radioEl: '<input type="radio" name="filter_<!--~filter.oid-->" id="<!--@getValId-->" class="form-check-input me-2" data-filter="<!--~filter.oid-->" value="<!--@getValValue-->"<!--!change@onCheckedChange-->>',
								labelEl: '<label for="<!--@getValId-->" class="form-check-label w-100"></label>'																
							}, {
								filter: filter,
								fnChange: fnChange,
								filterOptions: filterOptions,
								useShowMore: vars=>(vars.filter.values.length > self.options.visibleItemsCount ? '<!--#boxMoreEl--><!--#showMoreEl-->' : ''),
								renderVisibleItems: vars=>'<!--#radioWrapEl;$filter.values[:' + self.options.visibleItemsCount + ']-->'+(vars.filter.values.length<self.options.visibleItemsCount?'<!--#flexFiller;[:2]-->':''),
								renderInvisibleItems: vars=>'<!--#radioWrapEl;$filter.values[' + self.options.visibleItemsCount + ']--><!--#flexFiller[:2]-->',
								getValId: val=>self.getValId(filter.oid, val[filterOptions.valueProperty]),
								getValValue: val=>val[filterOptions.valueProperty],
								onCheckedChange: (e,el,vars)=>(fnChange(el.getAttribute('data-filter'), el.value, el.checked) && self.submit())
							})[0];
							
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let filterOptions = self.getFilterOptions(filter),
								i, radioEl, labelEl, unit, val1, val2;
							for (i = 0; i < filter.values.length; i++) {
								radioEl = scope.querySelector('#' + self.getValId(filter.oid, filter.values[i][filterOptions.valueProperty]));
								if (radioEl instanceof HTMLInputElement) {
									radioEl.checked = filter.values[i].selected;
									radioEl.disabled = filter.values[i].disabled;
									filter.selected = filter.selected || (filter.values[i][filterOptions.valueProperty] !== '' && filter.values[i].selected);

									labelEl = scope.querySelector('label[for="' + self.getValId(filter.oid, filter.values[i][filterOptions.valueProperty]) + '"]');
									if (labelEl instanceof HTMLElement) {
										unit = filter.values[i].unit || filter.unit;
										val1 = filter.values[i][filterOptions.valueProperty];
										val2 = filter.values[i].value2;
										labelEl.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
											+ (val2 ? '~' + val2 : '')
											+ (unit && (val1 || typeof val1 === 'number') ? ' ' + unit : '')
											+ (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
										if(radioEl.disabled){
											labelEl.classList.add('text-muted');
										} else {
											 labelEl.classList.remove('text-muted');
										}
									}
								}
							}
						},
						fnGenerateActive: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								activeWrapEl = document.createElement('div'),
								i, valueWrapEl, valueTextEl, val1, val2, unit, rmBtn;
							self.filters[filter.oid].active = false;

							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected && filter.values[i][filterOptions.valueProperty] !== '') {
									valueWrapEl = document.createElement('div');
									valueWrapEl.className = 'valueWrap';
									valueTextEl = document.createElement('span');
									val1 = filter.values[i][filterOptions.valueProperty];
									val2 = filter.values[i].value2;
									unit = filter.values[i].unit || filter.unit;
									valueTextEl.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
										+ (val2 ? '~' + val2 : '')
										+ (filter.unit && (val1 || typeof val1 === 'number') ? ' ' + unit : '')
										+ (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
									rmBtn = document.createElement('button');
									rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
									rmBtn.type = 'button';
									rmBtn.className = 'px-2';
									rmBtn.setAttribute('data-filter', filter.oid);
									rmBtn.setAttribute('data-value', filter.values[i][filterOptions.valueProperty]);
									rmBtn.addEventListener('click', function () {
										let filter = self.filters[this.getAttribute('data-filter')];
										let filterOptions = self.getFilterOptions(filter);
										if(filterOptions.fnChange(filter.oid, '', true)){
											filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
											self.submit();
										}
									});
									valueWrapEl.appendChild(valueTextEl);
									valueWrapEl.appendChild(rmBtn);
									activeWrapEl.appendChild(valueWrapEl);
								}
							}
							if (activeWrapEl.children.length > 0) {
								activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
									label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
									clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
								}, {
									filter: filter,
									clearFilter: clearFilter
								})[0]);
								self.filters[filter.oid].active = true;
								return activeWrapEl;
							}
							return false;
						},
						fnUpdate: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								hasEmptyVal = false,
								i, j, disabled, valueCount, _filter;
							filter.values = filter.values.sort(filterOptions.fnSortValues);

							for (i = 0; i < filter.values.length; i++) {
								if (filter.type === 'BOOLEAN') {
									if (filter.values[i].value == '0') {
										filter.values[i].name = EBContext.resource('NE');
									}
									if (filter.values[i].value == '1') {
										filter.values[i].name = EBContext.resource('ANO');
									}
								}
								if (filter.values[i].value == '') {
									hasEmptyVal = true;
								}
							}
							if (!hasEmptyVal) {
								filter.values.push({
									count: '',
									group: '',
									selected: true,
									value: '',
									oid: '',
									name: EBContext.resource('NEFILTROVAT')
								});
							}

							if (!self.filters.hasOwnProperty(filter.oid)) {
								self.filters[filter.oid] = filter;
							}
							_filter = self.filters[filter.oid],
							_filter.selected = false;

							for (i = 0; i < _filter.values.length; i++) {
								if (_filter.values[i].selected && (_filter.values[i].value || typeof _filter.values[i].value === 'number')) {
									_filter.selected = true;
									break;
								}
							}

							for (i = 0; i < _filter.values.length; i++) {
								disabled = !_filter.selected;
								valueCount = 0;

								// pro enum naplnit vlastnost name - mo�nost do budoucna u typu COLOR jako name pos�lat i n�zev barvy
								if (filterOptions.valueProperty !== 'value' && _filter.values[i].value) _filter.values[i].name = _filter.values[i].value;

								for (j = 0; j < filter.values.length; j++) {
									if (_filter.values[i].value == filter.values[j].value) {
										if (!_filter.selected && _filter.values[i].value == '') {
											_filter.values[i].selected = true;
										}
										if(!_filter.disabled) disabled = false;
										valueCount = filter.values[j].count;
										break;
									}
								}
								_filter.values[i].disabled = disabled;
								_filter.values[i].count = valueCount;
							}

						},
						fnChange: function (oid, value, selected) {
							let changed = false,
								filterOptions = self.getFilterOptions(self.filters[oid]),
								i;
							value = filterOptions.fnParseValue(value);
							for (i = 0; i < self.filters[oid].values.length; i++) {
								if (self.filters[oid].values[i][filterOptions.valueProperty] == value) {
									if(self.filters[oid].values[i].selected !== selected) changed = true;
									self.filters[oid].values[i].selected = selected;
								} else {
									if(self.filters[oid].values[i].selected) changed = true;
									self.filters[oid].values[i].selected = false;
								}
							}
							return changed;
						}
					},
					SELECT: {
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter)
							let filterDOM = EBContext.utils.template('<div><!--#selectEl--></div>', {
								selectEl: '<select class="form-control" id="filter_<!--~filter.oid-->" name="filter_<!--~filter.oid-->" aria-label="<!--~filter.name-->" data-filter="<!--~filter.oid-->"<!--!change@onChange-->><!--#optionEl;~filter.values--></select>',
								optionEl: '<option id="<!--@getValId-->" value="<!--@getValValue-->"></option>'																
							}, {
								filter: filter,
								fnChange: fnChange,
								filterOptions: filterOptions,
								getValId: val=>self.getValId(filter.oid, val[filterOptions.valueProperty]),
								getValValue: val=>val[filterOptions.valueProperty],
								onChange: (e,el,vars)=>(fnChange(el.getAttribute('data-filter'), el.value, true) && self.submit())
							})[0];
							
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let filterOptions = self.getFilterOptions(filter),
								selectEl = scope.querySelector('#filter_' + filter.oid),
								i, optionEl, unit, val1, val2;
							for (i = 0; i < filter.values.length; i++) {
								optionEl = scope.querySelector('#' + self.getValId(filter.oid, filter.values[i][filterOptions.valueProperty]));
								if (optionEl instanceof HTMLOptionElement) {
									optionEl.selected = filter.values[i].selected;
									optionEl.disabled = filter.values[i].disabled;
									filter.selected = filter.selected || (filter.values[i][filterOptions.valueProperty] !== '' && filter.values[i].selected);
									
									unit = filter.values[i].unit || filter.unit;
									val1 = filter.values[i][filterOptions.valueProperty];
									val2 = filter.values[i].value2;
									optionEl.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
										+ (val2 ? '~' + val2 : '')
										+ (unit && (val1 || typeof val1 === 'number') ? ' ' + unit : '')
										+ (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
								}
							}
							selectEl.disabled = filter.disabled;
						},
						fnGenerateActive: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								activeWrapEl = document.createElement('div'),
								i, valueWrapEl, valueTextEl, val1, val2, rmBtn;
							self.filters[filter.oid].active = false;
							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected && filter.values[i][filterOptions.valueProperty] !== '') {
									valueWrapEl = document.createElement('div');
									valueWrapEl.className = 'valueWrap';
									valueTextEl = document.createElement('span');
									val1 = filter.values[i][filterOptions.valueProperty];
									val2 = filter.values[i].value2
									valueTextEl.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
										 + (val2 ? '~' + val2 : '')
										 + (filter.unit && filter.values[i][filterOptions.valueProperty] !== '' ? ' ' + filter.unit : '')
										 + (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
									valueWrapEl.appendChild(valueTextEl);
									rmBtn = document.createElement('button');
									rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
									rmBtn.type = 'button';
									rmBtn.className = 'px-2';
									rmBtn.setAttribute('data-filter', filter.oid);
									rmBtn.setAttribute('data-value', filter.values[i][filterOptions.valueProperty]);
									rmBtn.addEventListener('click', function () {
										let filter = self.filters[this.getAttribute('data-filter')];
										let filterOptions = self.getFilterOptions(filter);
										if(filterOptions.fnChange(filter.oid, this.getAttribute('data-value'), false)){
											filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
											self.submit();
										}
									});
									valueWrapEl.appendChild(rmBtn);
									activeWrapEl.appendChild(valueWrapEl);
								}
							}
							if (activeWrapEl.children.length > 0) {
								activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
									label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
									clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
								}, {
									filter: filter,
									clearFilter: clearFilter
								})[0]);
								self.filters[filter.oid].active = true;
								return activeWrapEl;
							}
							return false;
						},
						fnChange: function (oid, value, selected) {
							let changed = false,
								filterOptions = self.getFilterOptions(self.filters[oid]),
								i;
							value = filterOptions.fnParseValue(value);
							for (i = 0; i < self.filters[oid].values.length; i++) {
								if (self.filters[oid].values[i][filterOptions.valueProperty] == value) {
									if(self.filters[oid].values[i].selected !== selected) changed = true;
									self.filters[oid].values[i].selected = selected;
								} else {
									if(self.filters[oid].values[i].selected) changed = true;
									self.filters[oid].values[i].selected = false;
								}
							}
							return changed;
						},
						fnUpdate: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								hasEmptyVal = false,
								i, j, _filter, disabled, valueCount;
							
							filter.values = filter.values.sort(filterOptions.fnSortValues);
							for (i = 0; i < filter.values.length; i++) {
								if (filter.type === 'BOOLEAN') {
									if (filter.values[i].value == '0') {
										filter.values[i].name = EBContext.resource('NE');
									}
									if (filter.values[i].value == '1') {
										filter.values[i].name = EBContext.resource('ANO');
									}
								}
								if (filter.values[i].value == '') {
									hasEmptyVal = true;
								}
							}
							if (!hasEmptyVal) {
								filter.values.push({
									count: '',
									group: '',
									selected: true,
									value: '',
									oid: '',
									name: EBContext.resource('NEFILTROVAT')
								});
							}

							if (!self.filters.hasOwnProperty(filter.oid)) {
								self.filters[filter.oid] = filter;
							}
							_filter = self.filters[filter.oid];
							_filter.selected = false;

							for (i = 0; i < _filter.values.length; i++) {
								if (_filter.values[i].selected && (_filter.values[i].value || typeof _filter.values[i].value === 'number')) {
									_filter.selected = true;
									break;
								}
							}

							for (i = 0; i < _filter.values.length; i++) {
								disabled = !_filter.selected;
								valueCount = 0;

								// pro enum naplnit vlastnost name - mo�nost do budoucna u typu COLOR jako name pos�lat i n�zev barvy
								if (filterOptions.valueProperty !== 'value' && _filter.values[i].value) _filter.values[i].name = _filter.values[i].value;

								if (!filter.disabled) {
									for (j = 0; j < filter.values.length; j++) {
										if (_filter.values[i].value == filter.values[j].value) {
											disabled = false;
											valueCount = filter.values[j].count;
											break;
										}
									}
								}
								_filter.values[i].disabled = disabled;
								_filter.values[i].count = valueCount;
							}
						}
					},
					MULTI_SELECT_SEARCH: {
						config: {
							actionsBox: true,
							liveSearch: true,
							width: false,
							_multiple: true
						},
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter),
								filterConfig = (filter.filterTypeConfig ? EBContext.utils.mergeObj(false, filterOptions.config, filter.filterTypeConfig) : filterOptions.config);
							let filterDOM = EBContext.utils.template('<div><!--#selectEl--></div>', {
								selectEl: '<select<!--@isMultiple--> class="w-100" id="filter_<!--~filter.oid-->" name="filter_<!--~filter.oid-->" aria-label="<!--~filter.name-->" data-filter="<!--~filter.oid-->"<!--!change@onChange-->><!--#optionEl;~filter.values--></select>',
								optionEl: '<option id="<!--@getValId-->" value="<!--@getValValue-->"></option>'
							}, {
								filter: filter,
								fnChange: fnChange,
								filterOptions: filterOptions,
								getValId: val => self.getValId(filter.oid, val[filterOptions.valueProperty]),
								getValValue: val => val[filterOptions.valueProperty] + (typeof val.value2 !== 'undefined' ? '~' + val.value2 : ''),
								onChange: (e, el, vars) => {
									let filter = self.filters[el.getAttribute('data-filter')],
										filterOptions = self.getFilterOptions(filter),
										values = [], i;
									for (i = 0; i < el.selectedOptions.length; i++) {
										values.push(filterOptions.fnParseValue(el.selectedOptions[i].value));
									}
									if(fnChange(el.getAttribute('data-filter'), values, true)) self.submit();
								},
								isMultiple: vars=>(filterConfig._multiple ? ' multiple' : '')
							})[0];
							
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							self.selects[filter.oid] = {
								elementId: 'filter_' + filter.oid,
								options: filterConfig
							};
							return filterDOM;
						},
						fnGenerateActive: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								activeWrapEl = document.createElement('div'),
								i, valueWrapEl, valueTextEl, val1, val2, rmBtn;
							self.filters[filter.oid].active = false;

							for (i = 0; i < filter.values.length; i++) {
								if (filter.values[i].selected && filter.values[i][filterOptions.valueProperty] !== '') {
									valueWrapEl = document.createElement('div');
									valueWrapEl.className = 'valueWrap';
									valueTextEl = document.createElement('span');
									val1 = filter.values[i][filterOptions.valueProperty];
									val2 = filter.values[i].value2
									valueTextEl.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
										 + (val2 ? '~' + val2 : '')
										 + (filter.unit && filter.values[i][filterOptions.valueProperty] !== '' ? ' ' + filter.unit : '')
										 + (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
									valueWrapEl.appendChild(valueTextEl);
									rmBtn = document.createElement('button');
									rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
									rmBtn.type = 'button';
									rmBtn.className = 'px-2';
									rmBtn.setAttribute('data-filter', filter.oid);
									rmBtn.setAttribute('data-value', filter.values[i][filterOptions.valueProperty]);
									rmBtn.addEventListener('click', function () {
										let filter = self.filters[this.getAttribute('data-filter')];
										let filterOptions = self.getFilterOptions(filter),
											activeValues = [],
											value = this.getAttribute('data-value'),
											i;
										for (i = 0; i < filter.values.length; i++) {
											if (filter.values[i].selected && filter.values[i].value !== filterOptions.fnParseValue(value)) activeValues.push(filter.values[i].value);
										}
										if(filterOptions.fnChange(filter.oid, activeValues, true)){
											filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
											self.submit();
										}
									});
									valueWrapEl.appendChild(rmBtn);
									activeWrapEl.appendChild(valueWrapEl);
								}
							}
							if (activeWrapEl.children.length > 0) {
								activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
									label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
									clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
								}, {
									filter: filter,
									clearFilter: clearFilter
								})[0]);
								self.filters[filter.oid].active = true;
								return activeWrapEl;
							}
							return false;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let filterOptions = self.getFilterOptions(filter),
								i, optionEl, unit, val1, val2;
							for (i = 0; i < filter.values.length; i++) {
								optionEl = scope.querySelector('#' + self.getValId(filter.oid, filter.values[i][filterOptions.valueProperty]));
								if (optionEl instanceof HTMLOptionElement) {
									optionEl.selected = filter.values[i].selected;
									optionEl.disabled = filter.values[i].disabled;
									filter.selected = filter.selected || filter.values[i].selected;
									
									unit = filter.values[i].unit || filter.unit;
									val1 = filter.values[i][filterOptions.valueProperty];
									val2 = filter.values[i].value2;
									optionEl.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
										 + (val2 ? '~' + val2 : '')
										 + (unit && (val1 || typeof val1 === 'number') ? ' ' + unit : '')
										 + (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
								}
							}
							require(['jquery', 'bootstrap-select'], (jQuery)=>{
								jQuery('#' + self.selects[filter.oid].elementId).selectpicker('refresh');
							});
						},
						fnChange: function (oid, values, selected) {
							let changed = false,
								filterOptions = self.getFilterOptions(self.filters[oid]),
								i, j;
							if (!Array.isArray(values)) values = [values];
							for (i = 0; i < self.filters[oid].values.length; i++) {
								self.filters[oid].values[i].selected = false;
								for (j = 0; j < values.length; j++) {
									if (self.filters[oid].values[i][filterOptions.valueProperty] === values[j]) {
										if(self.filters[oid].values[i].selected !== selected) changed = true;
										self.filters[oid].values[i].selected = selected;
										break;
									}
								}
							}
							return changed;
						}
					},
					NUMBER_INPUTS: {
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter);
							let filterDOM = EBContext.utils.template('<!--#filterWrapEl-->', {
								filterWrapEl: '<div class="row form-inline"><!--#inputMinWrap--><!--#inputMaxWrap--></div>',
								inputMinWrap: '<div class="col d-flex flex-grow-1"><!--#labelMinEl--><!--#inputMinEl--><!--#labelMinUnitEl--></div>',
								labelMinEl: '<label for="filter_<!--$filter.oid-->_min" class="my-2 pe-1 col-form-label justify-content-end text-end"><!--~resource.OD--></label>',
								inputMinEl: '<div class="d-flex flex-grow-1"><input type="number" id="filter_<!--$filter.oid-->_min" data-filter="<!--$filter.oid-->" min="<!--$filter.initMinValue-->" max="<!--@getMaxValue-->" class="form-control my-2 text-end nospinner d-flex flex-grow-1" style="min-width: 10ch" <!--!blur@onMinBlur--><!--!change@onInputChange-->></div>',
								labelMinUnitEl: '<label for="filter_<!--$filter.oid-->_min" class="col-auto my-2 ps-1 col-form-label justify-content-start text-start"><!--$filter.unit--></label>',
								inputMaxWrap: '<div class="col d-flex flex-grow-1"><!--#labelMaxEl--><!--#inputMaxEl--><!--#labelMaxUnitEl--></div>',
								labelMaxEl: '<label for="filter_<!--$filter.oid-->_max" class="my-2 pe-1 col-form-label justify-content-end text-end"><!--~resource.DO--></label>',
								inputMaxEl: '<div class="d-flex flex-grow-1"><input type="number" id="filter_<!--$filter.oid-->_max" data-filter="<!--$filter.oid-->" min="<!--@getMinValue-->" max="<!--$filter.initMaxValue-->" class="form-control my-2 text-end nospinner d-flex flex-grow-1" style="min-width: 10ch" <!--!blur@onMaxBlur--><!--!change@onInputChange-->></div>',
								labelMaxUnitEl: '<label for="filter_<!--$filter.oid-->_max" class="col-auto my-2 ps-1 col-form-label justify-content-start text-start"><!--$filter.unit--></label>'
							}, {
								filter: filter,
								fnChange: fnChange,
								filterOptions: filterOptions,
								getMaxValue: filter=>(filter.maxValue !== null ? filter.maxValue : filter.initMaxValue),
								getMinValue: filter=>(filter.minValue !== null ? filter.minValue : filter.initMinValue),
								onMinBlur: (e,el,vars)=>{
									if(vars.fnChange(el.getAttribute('data-filter'), el.value, null)) self.submit();
								},
								onMaxBlur: (e,el,vars)=>{
									if(vars.fnChange(el.getAttribute('data-filter'), null, el.value)) self.submit();
								},
								onInputChange: (e,el,vars)=>{
									if(self.sliders[el.getAttribute('data-filter')]){
										self.sliders[el.getAttribute('data-filter')].instanceObj.update({
											from: vars.filterOptions.fnParseValue(el.value)
										});
									}
								}								
							})[0];
							
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let inputMinEl = scope.querySelector('#filter_' + filter.oid + '_min'),
								inputMaxEl = scope.querySelector('#filter_' + filter.oid + '_max');
							if (inputMinEl instanceof HTMLInputElement) {
								if (typeof filter.boundaryMinValue === 'number') {
									inputMinEl.placeholder = filter.boundaryMinValue;
									inputMinEl.removeAttribute('disabled');
								} else if(filter.minValue === null) {
									inputMinEl.placeholder = filter.initMinValue;
									inputMinEl.setAttribute('disabled', '');
								}
								inputMinEl.value = (typeof filter.minValue === 'number' ? filter.minValue : '');
								filter.selected = filter.selected || (typeof filter.minValue === 'number');
							}
							if (inputMaxEl instanceof HTMLInputElement) {
								if (typeof filter.boundaryMaxValue === 'number') {
									inputMaxEl.placeholder = filter.boundaryMaxValue;
									inputMaxEl.removeAttribute('disabled');
								} else if(filter.maxValue === null) {
									inputMaxEl.placeholder = filter.initMaxValue;
									inputMaxEl.setAttribute('disabled', '');
								}
								inputMaxEl.value = (typeof filter.maxValue === 'number' ? filter.maxValue : '');
								filter.selected = filter.selected || (typeof filter.maxValue === 'number');
							}
						},
						fnGenerateActive: function (filter) {
							let activeWrapEl = document.createElement('div'),
								filterOptions = self.getFilterOptions(filter),
								valueWrapEl, valueTextEl, minVal, maxVal, minValUnit, maxValUnit, minValObj, maxValObj, rmBtn;
							self.filters[filter.oid].active = false;

							if (typeof filter.minValue === 'number' || typeof filter.maxValue === 'number') {
								valueWrapEl = document.createElement('div');
								valueWrapEl.className = 'valueWrap';
								valueTextEl = document.createElement('span');
                                minVal = filter.minValue;
                                if(typeof minVal !== 'number') minVal = filter.boundaryMinValue;
                                if(typeof minVal !== 'number') minVal = filter.initMinValue;
                                maxVal = filter.maxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.boundaryMaxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.initMaxValue;
								
								minValUnit = '';
								maxValUnit = filter.unit;
								if(filterOptions.config._multiUnitActive){
									minValObj = filter.values.find(val=>(val.value===minVal));
									if (minValObj) {
										minVal = minVal * minValObj.koef;
										minValUnit = (minValObj.unit ? ' ' + minValObj.unit : '');
									}
									maxValObj = filter.values.find(val=>(val.value===maxVal));
									if(maxValObj){
										maxVal = maxVal * maxValObj.koef;
										maxValUnit = maxValObj.unit || filter.unit;
									}
								}
								valueTextEl.innerText = minVal + minValUnit + ' ~ ' + maxVal + (maxValUnit ? ' ' + maxValUnit : '');
								
								rmBtn = document.createElement('button');
								rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
								rmBtn.type = 'button';
								rmBtn.className = 'px-2';
								rmBtn.setAttribute('data-filter', filter.oid);
								rmBtn.addEventListener('click', function () {
									let filter = self.filters[this.getAttribute('data-filter')];
									let filterOptions = self.getFilterOptions(filter);
									if(filterOptions.fnChange(filter.oid, '', '')){
										filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
										self.submit();
									}
								});
								valueWrapEl.appendChild(valueTextEl);
								valueWrapEl.appendChild(rmBtn);
								activeWrapEl.appendChild(valueWrapEl);
								activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
									label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
									clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
								}, {
									filter: filter,
									clearFilter: clearFilter
								})[0]);
								self.filters[filter.oid].active = true;
								return activeWrapEl;
							}
							return false;
						},
						fnChange: function (oid, min, max) {
							let changed = false,
								filterOptions = self.getFilterOptions(self.filters[oid]),
								pMin = filterOptions.fnParseValue(min),
								pMax = filterOptions.fnParseValue(max);
							if(isNaN(pMin)) pMin = null;
							if(isNaN(pMax)) pMax = null;
							
							if (min !== null && self.filters[oid].minValue != pMin) {
								self.filters[oid].minValue = pMin;
								changed = true;
							}
							if (max !== null && self.filters[oid].maxValue != pMax) {
								self.filters[oid].maxValue = pMax;
								changed = true;
							}
							return changed;
						},
						fnUpdate: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								_filter, filterMin, filterMax, i, j, valueCount;
							filter.values = filter.values.sort(filterOptions.fnSortValues);
							
							// Pokud hodnota n�hodou mezi p�vodn�mi filtry neexistuje (nap�. filtr se ji� na�etl zafiltrovan�), tak se p�id�
							if (!(self.filters.hasOwnProperty(filter.oid))) {
								self.filters[filter.oid] = filter;
							}
							_filter = self.filters[filter.oid];

							filterMin = null;
							filterMax = null;
							for (i = 0; i < _filter.values.length; i++) {
								valueCount = 0;
								if (!filter.disabled) {
									for (j = 0; j < filter.values.length; j++) {
										if (_filter.values[i].value == filter.values[j].value && _filter.values[i].value2 == filter.values[j].value2) {
											valueCount = filter.values[j].count;
											if (filterMin === null || filter.values[j].value < filterMin) {
												filterMin = filter.values[j].value;
											}
											if (filterMax === null || filter.values[j].value2 > filterMax) {
												filterMax = filter.values[j].value2;
											}
											if (!filter.values[j].value2 && filter.values[j].value > filterMax) {
												filterMax = filter.values[j].value;
											}
											break;
										}
									}
								}
							}

							// Nastaven� p�vodn� min/max hodnoty filtru
							if (!_filter.hasOwnProperty('initMinValue')) _filter.initMinValue = filterMin;
							if (!_filter.hasOwnProperty('initMaxValue')) _filter.initMaxValue = filterMax;

							_filter.boundaryMinValue = filterMin;
							_filter.boundaryMaxValue = filterMax;

							if (typeof _filter.minValue !== 'number') {
								_filter.minValue = (filterMin > _filter.boundaryMinValue ? filterMin : null);
							}
							if (typeof _filter.maxValue !== 'number') {
								_filter.maxValue = (filterMax < _filter.boundaryMaxValue ? filterMax : null);
							}

						},
						fnStringify: function (filter) {
							return filter.oid + ':::' + filter.type + ':::' + (typeof filter.minValue === 'number' ? filter.minValue.toString().replace(/\./g, ',') : '') + '@@@' + (typeof filter.maxValue === 'number' ? filter.maxValue.toString().replace(/\./g, ',') : '') + '###';
						}
					},
					SLIDER_INPUTS: {
						config: {
							type: 'double',
							grid: true,
							drag_interval: true,
							decorate_both: false,
							force_edges: true
						},
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter),
								filterConfig = (filter.filterTypeConfig ? EBContext.utils.mergeObj(false, filterOptions.config, filter.filterTypeConfig) : filterOptions.config);
							let themeClass = filterOptions.fnGenerateFilterStyles(filter.filterType, filterConfig);
							let filterDOM = EBContext.utils.template('<!--#filterWrapEl-->', {
								filterWrapEl: '<div class="row form-inline <!--$themeClass-->"><!--#sliderWrapEl--><!--#inputMinWrap--><!--#inputMaxWrap--></div>',
								sliderWrapEl: '<div class="col-12"><input type="range" id="filter_<!--$filter.oid-->_slider" class="col-8 offset-2" aria-label="<!--~filter.name-->" data-filter="<!--$filter.oid-->"></div>',
								inputMinWrap: '<div class="col d-flex flex-grow-1"><!--#labelMinEl--><!--#inputMinEl--><!--#labelMinUnitEl--></div>',
								labelMinEl: '<label for="filter_<!--$filter.oid-->_min" class="my-2 pe-1 col-form-label justify-content-end text-end"><!--~resource.OD--></label>',
								inputMinEl: '<div class="d-flex flex-grow-1"><input type="number" id="filter_<!--$filter.oid-->_min" data-filter="<!--$filter.oid-->" min="<!--$filter.initMinValue-->" max="<!--@getMaxValue-->" class="form-control my-2 text-end nospinner d-flex flex-grow-1" style="min-width: 10ch" <!--!blur@onMinBlur--><!--!change@onInputChange-->></div>',
								labelMinUnitEl: '<label for="filter_<!--$filter.oid-->_min" class="col-auto my-2 ps-1 col-form-label justify-content-start text-start"><!--$filter.unit--></label>',
								inputMaxWrap: '<div class="col d-flex flex-grow-1"><!--#labelMaxEl--><!--#inputMaxEl--><!--#labelMaxUnitEl--></div>',
								labelMaxEl: '<label for="filter_<!--$filter.oid-->_max" class="my-2 pe-1 col-form-label justify-content-end text-end"><!--~resource.DO--></label>',
								inputMaxEl: '<div class="d-flex flex-grow-1"><input type="number" id="filter_<!--$filter.oid-->_max" data-filter="<!--$filter.oid-->" min="<!--@getMinValue-->" max="<!--$filter.initMaxValue-->" class="form-control my-2 text-end nospinner d-flex flex-grow-1" style="min-width: 10ch" <!--!blur@onMaxBlur--><!--!change@onInputChange-->></div>',
								labelMaxUnitEl: '<label for="filter_<!--$filter.oid-->_max" class="col-auto my-2 ps-1 col-form-label justify-content-start text-start"><!--$filter.unit--></label>'
							}, {
								filter: filter,
								fnChange: fnChange,
								themeClass: themeClass,
								filterOptions: filterOptions,
								getMaxValue: filter=>(filter.maxValue !== null ? filter.maxValue : filter.initMaxValue),
								getMinValue: filter=>(filter.minValue !== null ? filter.minValue : filter.initMinValue),
								onMinBlur: (e,el,vars)=>{
									if(vars.fnChange(el.getAttribute('data-filter'), el.value, null)) self.submit();
								},
								onMaxBlur: (e,el,vars)=>{
									if(vars.fnChange(el.getAttribute('data-filter'), null, el.value)) self.submit();
								},
								onInputChange: (e,el,vars)=>{
									if(self.sliders[el.getAttribute('data-filter')]){
										if(el.id.substr(-3)==='min'){
											self.sliders[el.getAttribute('data-filter')].instanceObj.update({
												from: vars.filterOptions.fnParseValue(el.value)
											});
										} else if(el.id.substr(-3)==='max'){
											self.sliders[el.getAttribute('data-filter')].instanceObj.update({
												to: vars.filterOptions.fnParseValue(el.value)
											});
										}
									}
								}								
							})[0];

							self.sliders[filter.oid] = {
								elementId: 'filter_' + filter.oid + '_slider',
								options: EBContext.utils.extendObj(false, {
									min: filter.boundaryMinValue,
									max: filter.boundaryMaxValue,
									from: (typeof filter.minValue === 'number' ? filter.minValue : (typeof filter.boundaryMinValue === 'number' ? filter.boundaryMinValue : filter.initMinValue)),
									to: (typeof filter.maxValue === 'number' ? filter.maxValue : (typeof filter.boundaryMaxValue === 'number' ? filter.boundaryMaxValue : filter.initMaxValue)),
									postfix: (filter.unit ? ' ' + filter.unit : ''),
									onChange: function (data) {
										let inputMinEl = document.getElementById('filter_' + filter.oid + '_min');
										if(inputMinEl) inputMinEl.value = data.from;
										let inputMaxEl = document.getElementById('filter_' + filter.oid + '_max');
										if(inputMaxEl) inputMaxEl.value = data.to;
									},
									onFinish: function (data) {
										if (data.from === data.min && data.to === data.max) {
											if(fnChange(filter.oid, null, null)) self.submit();
										} else {
											if(fnChange(filter.oid, data.from, data.to)) self.submit();
										}
									}
								}, filterConfig)
							};
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnGenerateFilterStyles: generateSliderStyles,
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							let inputMinEl = scope.querySelector('#filter_' + filter.oid + '_min'),
								inputMaxEl = scope.querySelector('#filter_' + filter.oid + '_max'),
								sliderObj = (self.sliders[filter.oid] ? self.sliders[filter.oid].instanceObj : null),
								boundaryMin = (typeof filter.boundaryMinValue === 'number' ? filter.boundaryMinValue : filter.initMinValue),
								boundaryMax = (typeof filter.boundaryMaxValue === 'number' ? filter.boundaryMaxValue : filter.initMaxValue),
								valMin = (typeof filter.minValue === 'number' ? filter.minValue : boundaryMin),
								valMax = (typeof filter.maxValue === 'number' ? filter.maxValue : boundaryMax),
								sliderUpdate = {
									min: filter.initMinValue,
									max: filter.initMaxValue,
									from: valMin,
									to: valMax,
									disable: filter.disabled
									// from_min: (filter.selected ? filter.initMinValue : boundaryMin),
									// to_min: valMin,
									// from_max: valMax,
									// to_max: (filter.selected ? filter.initMaxValue : boundaryMax)
								};
								
							if (sliderObj) {
								sliderObj.update(sliderUpdate);
							} else {
								self.sliders[filter.oid].options = EBContext.utils.mergeObj(false, self.sliders[filter.oid].options, sliderUpdate);
							}

							if (inputMinEl instanceof HTMLInputElement) {
								inputMinEl.placeholder = boundaryMin;
								if (typeof filter.boundaryMinValue === 'number') {
									inputMinEl.removeAttribute('disabled');
								} else if(filter.minValue === null) {
									inputMinEl.setAttribute('disabled', '');
								}
								inputMinEl.value = (typeof filter.minValue === 'number' ? filter.minValue : '');
								inputMinEl.setAttribute('max', (typeof filter.maxValue === 'number' ? filter.maxValue : (typeof filter.boundaryMaxValue === 'number' ? filter.boundaryMaxValue : filter.initMaxValue)));
							}

							if (inputMaxEl instanceof HTMLInputElement) {
								if (typeof filter.boundaryMaxValue === 'number') {
									inputMaxEl.placeholder = filter.boundaryMaxValue;
									inputMaxEl.removeAttribute('disabled');
								} else if(filter.maxValue === null) {
									inputMaxEl.placeholder = filter.initMaxValue;
									inputMaxEl.setAttribute('disabled', '');
								}
								inputMaxEl.value = (typeof filter.maxValue === 'number' ? filter.maxValue : '');
								inputMaxEl.setAttribute('min', (typeof filter.minValue === 'number' ? filter.minValue : (typeof filter.boundaryMinValue === 'number' ? filter.boundaryMinValue : filter.initMinValue)));
							}
							filter.selected = (valMin !== boundaryMin || valMax !== boundaryMax);
						},
						fnGenerateActive: function (filter) {
							let activeWrapEl = document.createElement('div'),
								filterOptions = self.getFilterOptions(filter),
								valueWrapEl, valueTextEl, minVal, maxVal, minValUnit, maxValUnit, minValObj, maxValObj, rmBtn;
                            self.filters[filter.oid].active = false;

							if (typeof filter.minValue === 'number' || typeof filter.maxValue === 'number') {
								valueWrapEl = document.createElement('div');
								valueWrapEl.className = 'valueWrap';
								valueTextEl = document.createElement('span');
								minVal = filter.minValue;
                                if(typeof minVal !== 'number') minVal = filter.boundaryMinValue;
                                if(typeof minVal !== 'number') minVal = filter.initMinValue;
                                maxVal = filter.maxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.boundaryMaxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.initMaxValue;
								minValUnit = '';
								maxValUnit = filter.unit;
								if (filterOptions.config._multiUnitActive) {
									minValObj = filter.values.find(val => (val.value === minVal));
									if (minValObj) {
										minVal = minVal * minValObj.koef;
										minValUnit = (minValObj.unit ? ' ' + minValObj.unit : '');
									}
									maxValObj = filter.values.find(val => (val.value === maxVal));
									if (maxValObj) {
										maxVal = maxVal * maxValObj.koef;
										maxValUnit = maxValObj.unit || filter.unit;
									}
								}
								valueTextEl.innerText = minVal + minValUnit + ' ~ ' + maxVal + (maxValUnit ? ' ' + maxValUnit : '');
								
								rmBtn = document.createElement('button');
								rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
								rmBtn.type = 'button';
								rmBtn.className = 'px-2';
								rmBtn.setAttribute('data-filter', filter.oid);
								rmBtn.addEventListener('click', function () {clearFilter(null,this)});
								valueWrapEl.appendChild(valueTextEl);
								valueWrapEl.appendChild(rmBtn);
								activeWrapEl.appendChild(valueWrapEl);
								activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
									label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
									clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
								}, {
									filter: filter,
									clearFilter: clearFilter
								})[0]);
								self.filters[filter.oid].active = true;
								return activeWrapEl;
							}
							return false;
						},
						fnChange: function (oid, min, max) {
							let changed = false,
								filterOptions = self.getFilterOptions(self.filters[oid]),
								filter = self.filters[oid];

							if(min===null && max===null){
								changed = (min!==filter.minValue || max!==filter.maxValue);
								filter.minValue = null;
								filter.boundaryMinValue = null;
								filter.maxValue = null;
								filter.boundaryMaxValue = null;
								return changed;
							}								
							min = filterOptions.fnParseValue((min !== null ? min : filter.minValue));
							max = filterOptions.fnParseValue((max !== null ? max : filter.maxValue));
							if (min === filter.initMinValue) min = null;
							if (max === filter.initMaxValue) max = null;
							if (filter.minValue === filter.initMinValue) {
								filter.minValue = null;
								filter.boundaryMinValue = null;
							}
							if (filter.maxValue === filter.initMaxValue) {
								filter.maxValue = null;
								filter.boundaryMaxValue = null;
							}
							if (filter.minValue != min && !(filter.minValue === null && min === filter.boundaryMinValue)) {
								filter.minValue = min;
								changed = true;
							}
							if (filter.maxValue != max && !(filter.maxValue === null && max === filter.boundaryMaxValue)) {
								filter.maxValue = max;
								changed = true;
							}
							return changed;
						},
						fnUpdate: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								_filter, filterMin, filterMax, i, j, valueCount;
							filter.values = filter.values.sort(filterOptions.fnSortValues);
							// Pokud hodnota n�hodou mezi p�vodn�mi filtry neexistuje (nap�. filtr se ji� na�etl zafiltrovan�), tak se p�id�
							if (!(self.filters.hasOwnProperty(filter.oid))) {
								self.filters[filter.oid] = filter;
							}
							_filter = self.filters[filter.oid];

							// Je n�kter� hodnota (a tedy i filtr jako takov�) aktivn�/selected?
							_filter.selected = (typeof _filter.minValue === 'number' || typeof _filter.maxValue === 'number');

							filterMin = null;
							filterMax = null;
							for (i = 0; i < _filter.values.length; i++) {
								valueCount = 0;
								if (!filter.disabled) {
									for (j = 0; j < filter.values.length; j++) {
										if (_filter.values[i].value == filter.values[j].value && _filter.values[i].value2 == filter.values[j].value2) {
											valueCount = filter.values[j].count;
											if (filterMin === null || filter.values[j].value < filterMin) {
												filterMin = filter.values[j].value;
											}
											if (filterMax === null || filter.values[j].value2 > filterMax) {
												filterMax = filter.values[j].value2;
											}
											if (typeof filter.values[j].value2 !== 'number' || filter.values[j].value > filterMax) {
												filterMax = filter.values[j].value;
											}
											break;
										}
									}
								}
							}
							// O�et�en� filtru ceny - nepos�l� v��et hodnot, ale jen krajn� hodnoty
							if(filterMin===filterMax && filter.values.length === 2){
								filterMin = filter.values[0].value;
								filterMax = filter.values[1].value2 || filter.values[1].value;
							}

							// Nastaven� p�vodn� min/max hodnoty filtru
							if (!_filter.hasOwnProperty('initMinValue')) _filter.initMinValue = filterMin;
							if (!_filter.hasOwnProperty('initMaxValue')) _filter.initMaxValue = filterMax;

							if (!_filter.selected) {
								_filter.boundaryMinValue = filterMin;
								_filter.boundaryMaxValue = filterMax;
							} else {
								_filter.boundaryMinValue = _filter.initMinValue;
								_filter.boundaryMaxValue = _filter.initMaxValue;
							}

							if (false && _filter.selected && typeof _filter.minValue !== 'number') {
								_filter.minValue = (filterMin > _filter.boundaryMinValue ? filterMin : null);
							}
							if (false && _filter.selected && typeof _filter.maxValue !== 'number') {
								_filter.maxValue = (filterMax < _filter.boundaryMaxValue ? filterMax : null);
							}
						},
						fnStringify: function (filter) {
							return filter.oid + ':::' + filter.type + ':::' + (typeof filter.minValue === 'number' ? filter.minValue.toString().replace(/\./g, ',') : '') + '@@@' + (typeof filter.maxValue === 'number' ? filter.maxValue.toString().replace(/\./g, ',') : '') + '###';
						}
					},
					SLIDER_STEPS: {
						config: {
							type: 'double',
							grid: true,
							drag_interval: true,
							decorate_both: false,
							force_edges: true
						},
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter),
								filterConfig = (filter.filterTypeConfig ? EBContext.utils.mergeObj(false, filterOptions.config, filter.filterTypeConfig) : filterOptions.config);
							let themeClass = filterOptions.fnGenerateFilterStyles(filter.filterType, filterConfig);
							let filterDOM = EBContext.utils.template('<!--#filterWrapEl-->', {
								filterWrapEl: '<div class="row form-inline <!--$themeClass-->"><!--#sliderWrapEl--></div>',
								sliderWrapEl: '<div class="col-12"><input type="range" id="filter_<!--$filter.oid-->_slider" aria-label="<!--~filter.name-->" class="col-8 offset-2" data-filter="<!--$filter.oid-->"></div>',
							}, {
								filter: filter,
								themeClass: themeClass
							})[0];
							
							self.sliders[filter.oid] = {
								elementId: 'filter_' + filter.oid + '_slider',
								options: EBContext.utils.extendObj(false, {
									min: filter.initMinIndex,
									max: filter.initMaxIndex,
									from: (typeof filter.minIndex === 'number' ? filter.minIndex : (filter.boundaryMinIndex > -1 ? filter.boundaryMinIndex : 0)),
									to: (typeof filter.maxIndex === 'number' ? filter.maxIndex : (filter.boundaryMaxIndex > -1 ? filter.boundaryMaxIndex : filter.values.length)),
									values: filter.valuesArr,
									onFinish: function (data) {
										if (data.from === data.min && data.to === data.max) {
											if(fnChange(filter.oid, null, null)) self.submit();
										} else {
											if(fnChange(filter.oid, filter.numValuesArr[data.from], filter.numValuesArr[data.to])) self.submit();
										}
									}
								}, filterConfig)
							};
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnGenerateFilterStyles: generateSliderStyles,
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							let sliderObj = (self.sliders[filter.oid] ? self.sliders[filter.oid].instanceObj : null),
								boundaryMin = (typeof filter.boundaryMinValue === 'number' ? filter.boundaryMinValue : filter.initMinValue),
								boundaryMax = (typeof filter.boundaryMaxValue === 'number' ? filter.boundaryMaxValue : filter.initMaxValue),
								minIndex = (typeof filter.minIndex === 'number' ? filter.minIndex : filter.numValuesArr.indexOf(boundaryMin)),
								maxIndex = (typeof filter.maxIndex === 'number' ? filter.maxIndex : filter.numValuesArr.indexOf(boundaryMax)),
								sliderUpdate = {
									min: filter.initMinIndex,
									max: filter.initMaxIndex,
									from: minIndex,
									to: maxIndex,
									disable: filter.disabled
								};
								
							if (sliderObj) {
								sliderObj.update(sliderUpdate);
							} else {
								self.sliders[filter.oid].options = EBContext.utils.mergeObj(false, self.sliders[filter.oid].options, sliderUpdate);
							}
						},
						fnGenerateActive: function (filter) {
							let activeWrapEl = document.createElement('div'),
								valueWrapEl, valueTextEl, minVal, maxVal, minValUnit, maxValUnit, minValObj, maxValObj, rmBtn;
							self.filters[filter.oid].active = false;

							if (filter.selected) {
								let filterOptions = self.getFilterOptions(filter);
								
								valueWrapEl = document.createElement('div');
								valueWrapEl.className = 'valueWrap';
								valueTextEl = document.createElement('span');
								minVal = filter.minValue;
                                if(typeof minVal !== 'number') minVal = filter.boundaryMinValue;
                                if(typeof minVal !== 'number') minVal = filter.initMinValue;
                                maxVal = filter.maxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.boundaryMaxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.initMaxValue;
								minValUnit = '';
								maxValUnit = filter.unit;
								if (filterOptions.config._multiUnitActive) {
									minValObj = filter.values.find(val => (val.value === minVal));
									if (minValObj) {
										minVal = minVal * minValObj.koef;
										minValUnit = (minValObj.unit ? ' ' + minValObj.unit : '');
									}
									maxValObj = filter.values.find(val => (val.value === maxVal));
									if (maxValObj) {
										maxVal = maxVal * maxValObj.koef;
										maxValUnit = maxValObj.unit || filter.unit;
									}
								}
								valueTextEl.innerText = minVal + minValUnit + ' ~ ' + maxVal + (maxValUnit ? ' ' + maxValUnit : '');
								
								rmBtn = document.createElement('button');
								rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
								rmBtn.type = 'button';
								rmBtn.className = 'px-2';
								rmBtn.setAttribute('data-filter', filter.oid);
								rmBtn.addEventListener('click', function () {
									let filter = self.filters[this.getAttribute('data-filter')];
									let filterOptions = self.getFilterOptions(filter);
									if(filterOptions.fnChange(filter.oid, null, null)){
										filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
										self.submit();
									}
								});
								valueWrapEl.appendChild(valueTextEl);
								valueWrapEl.appendChild(rmBtn);
								activeWrapEl.appendChild(valueWrapEl);
								activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
									label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
									clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
								}, {
									filter: filter,
									clearFilter: clearFilter
								})[0]);
								self.filters[filter.oid].active = true;
								return activeWrapEl;
							}
							return false;
						},
						fnChange: function (oid, min, max) {
							let changed = false,
								filterOptions = self.getFilterOptions(self.filters[oid]),
								filter = self.filters[oid];
							min = filterOptions.fnParseValue(min);
							max = filterOptions.fnParseValue(max);
							if (min === filter.initMinValue) {
								filter.minValue = null;
								filter.minIndex = null;
								filter.boundaryMinValue = null;
								filter.boundaryMinIndex = null;
							}
							if (max === filter.initMaxValue) {
								filter.maxValue = null;
								filter.maxIndex = null;
								filter.boundaryMaxValue = null;
								filter.boundaryMaxIndex = null;
							}
							if (filter.minValue != filterOptions.fnParseValue(min)) {
								filter.minValue = filterOptions.fnParseValue(min);
								filter.minIndex = (filter.minValue === null ? null : filter.values.findIndex(i=>i.value===filter.minValue));
								changed = true;
							}
							if (filter.maxValue != filterOptions.fnParseValue(max)) {
								filter.maxValue = filterOptions.fnParseValue(max);
								filter.maxIndex = (filter.maxValue === null ? null : filter.values.findIndex(i=>i.value===filter.maxValue));
								changed = true;
							}
							return changed;
						},
						fnClear: function(oid) {
							let filterOptions = self.getFilterOptions(self.filters[oid])
							filterOptions.fnChange(oid, null, null);
							return false;
						},
						fnUpdate: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								_filter = self.filters[filter.oid],
								i, j, valFound, valExists, unit, val1, val2;

							// Pokud filtr n�hodou mezi p�vodn�mi filtry neexistuje (nap�. filtr se ji� na�etl zafiltrovan�), tak se p�id�
							if (_filter===undefined) {
								self.filters[filter.oid] = filter;
								_filter = filter;
							}
							// Jinak se jen p�ekop�ruje aktu�ln� stav, dopln� se nov� hodnoty, a disabluj� se neaktu�ln�
							else {
								// doplnit nov� hodnoty
								filter.values.forEach(a=>{
									valExists = (_filter.values.find(b=>(b[filterOptions.valueProperty] === a[filterOptions.valueProperty])) !== undefined);
									if(!valExists) _filter.values.push(a);
								});
								
								// disablovat nerelevantn� existuj�c� hodnoty
								_filter.values.forEach(a=>{
									a.disabled = (filter.values.find(b=>(b[filterOptions.valueProperty] === a[filterOptions.valueProperty])) === undefined);
								});
							}
							
							_filter.selected = (typeof _filter.minValue === 'number' || typeof _filter.maxValue === 'number');
							
							// Se�adit hodnoty filtru aby se nov� za�azen� hodnoty vkl�daly systematicky a ne v�dy na konec; zp�sob �azen� lze p�et�it vlastn� sort fn.
							_filter.values = _filter.values.sort(filterOptions.fnSortValues);

							// Napln� relevantn� hodnoty do ploch�ho pole pro slider
							_filter.valuesArr = [];
							_filter.numValuesArr = [];
							for (i = 0; i < _filter.values.length; i++) {
								unit = _filter.values[i].unit || _filter.unit;
								val1 = _filter.values[i][filterOptions.valueProperty];
								val2 = _filter.values[i].value2;
								_filter.valuesArr.push((_filter.values[i].hasOwnProperty('name') ? _filter.values[i].name : val1) + (unit && (val1 || typeof val1 === 'number') ? ' ' + unit : ''));
								_filter.numValuesArr.push(val1);
							}							
							
							// Nastav� min/max povolenou hodnotu filtru
							_filter.boundaryMinIndex = _filter.values.findIndex(a=>!a.disabled);
							_filter.boundaryMaxIndex = EBContext.utils.array.findLastIndexOf(_filter.values, a=>!a.disabled);
							_filter.boundaryMinValue = _filter.values[_filter.boundaryMinIndex][filterOptions.valueProperty];
							_filter.boundaryMaxValue = _filter.values[_filter.boundaryMaxIndex][filterOptions.valueProperty];

							// Nastaven� v�choz� min/max hodnoty filtru
							if (_filter.initMinIndex === undefined) _filter.initMinIndex = _filter.boundaryMinIndex;
							if (_filter.initMaxIndex === undefined) _filter.initMaxIndex = _filter.boundaryMaxIndex;
							if (_filter.initMinValue === undefined) _filter.initMinValue = _filter.boundaryMinValue;
							if (_filter.initMaxValue === undefined) _filter.initMaxValue = _filter.boundaryMaxValue;
						},
						fnStringify: function (filter) {
							return filter.oid + ':::' + filter.type + ':::' + (typeof filter.minValue === 'number' ? filter.minValue.toString().replace(/\./g, ',') : '') + '@@@' + (typeof filter.maxValue === 'number' ? filter.maxValue.toString().replace(/\./g, ',') : '') + '###';
						}
					},
					SLIDER_ONLY: {
						config: {
							type: 'double',
							grid: true,
							drag_interval: true,
							decorate_both: false,
							force_edges: true
						},
						fnGenerateFilterBody: function (filter, fnChange) {
							let filterOptions = self.getFilterOptions(filter),
								filterConfig = (filter.filterTypeConfig ? EBContext.utils.mergeObj(false, filterOptions.config, filter.filterTypeConfig) : filterOptions.config);
							let themeClass = filterOptions.fnGenerateFilterStyles(filter.filterType, filterConfig);
							let filterDOM = EBContext.utils.template('<!--#filterWrapEl-->', {
								filterWrapEl: '<div class="row form-inline <!--$themeClass-->"><!--#sliderWrapEl--></div>',
								sliderWrapEl: '<div class="col-12"><input type="range" aria-label="<!--~filter.name-->" id="filter_<!--$filter.oid-->_slider" class="col-8 offset-2" data-filter="<!--$filter.oid-->"></div>',
							}, {
								filter: filter,
								themeClass: themeClass
							})[0];

							self.sliders[filter.oid] = {
								elementId: 'filter_' + filter.oid + '_slider',
								options: EBContext.utils.extendObj(false, {
									min: filter.boundaryMinValue,
									max: filter.boundaryMaxValue,
									from: (typeof filter.minValue === 'number' ? filter.minValue : (typeof filter.boundaryMinValue === 'number' ? filter.boundaryMinValue : filter.initMinValue)),
									to: (typeof filter.maxValue === 'number' ? filter.maxValue : (typeof filter.boundaryMaxValue === 'number' ? filter.boundaryMaxValue : filter.initMaxValue)),
									postfix: (filter.unit ? ' ' + filter.unit : ''),
									onFinish: function (data) {
										if (data.from === data.min && data.to === data.max) {
											if(fnChange(filter.oid, null, null)) self.submit();
										} else {
											if(fnChange(filter.oid, data.from, data.to)) self.submit();
										}
									}
								}, filterConfig)
							};
							filterOptions.fnUpdateFilterValues(filter, filterDOM);
							return filterDOM;
						},
						fnGenerateFilterStyles: generateSliderStyles,
						fnUpdateFilterValues: function (filter, scope) {
							scope = scope || document;
							filter.selected = false;
							let sliderObj = (self.sliders[filter.oid] ? self.sliders[filter.oid].instanceObj : null),
								boundaryMin = (typeof filter.boundaryMinValue === 'number' ? filter.boundaryMinValue : filter.initMinValue),
								boundaryMax = (typeof filter.boundaryMaxValue === 'number' ? filter.boundaryMaxValue : filter.initMaxValue),
								valMin = (typeof filter.minValue === 'number' ? filter.minValue : boundaryMin),
								valMax = (typeof filter.maxValue === 'number' ? filter.maxValue : boundaryMax),
								sliderUpdate = {
									min: filter.initMinValue,
									max: filter.initMaxValue,
									from: valMin,
									to: valMax,
									disable: filter.disabled
									// from_min: (filter.selected ? filter.initMinValue : boundaryMin),
									// to_min: valMin,
									// from_max: valMax,
									// to_max: (filter.selected ? filter.initMaxValue : boundaryMax)
								};
							
							if (sliderObj) {
								sliderObj.update(sliderUpdate);
							} else {
								self.sliders[filter.oid].options = EBContext.utils.mergeObj(false, self.sliders[filter.oid].options, sliderUpdate);
							}
							filter.selected = (valMin !== filter.initMinValue || valMax !== filter.initMaxValue);
						},
						fnGenerateActive: function (filter) {
							let activeWrapEl = document.createElement('div'),
								valueWrapEl, valueTextEl, minVal, maxVal, minValUnit, maxValUnit, minValObj, maxValObj, rmBtn;
							self.filters[filter.oid].active = false;

							if (typeof filter.minValue === 'number' || typeof filter.maxValue === 'number') {
								valueWrapEl = document.createElement('div');
								valueWrapEl.className = 'valueWrap';
								valueTextEl = document.createElement('span');
								minVal = filter.minValue;
                                if(typeof minVal !== 'number') minVal = filter.boundaryMinValue;
                                if(typeof minVal !== 'number') minVal = filter.initMinValue;
                                maxVal = filter.maxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.boundaryMaxValue;
                                if(typeof maxVal !== 'number') maxVal = filter.initMaxValue;
								minValUnit = '';
								maxValUnit = filter.unit;
								if (filterOptions.config._multiUnitActive) {
									minValObj = filter.values.find(val => (val.value === minVal));
									if (minValObj) {
										minVal = minVal * minValObj.koef;
										minValUnit = (minValObj.unit ? ' ' + minValObj.unit : '');
									}
									maxValObj = filter.values.find(val => (val.value === maxVal));
									if (maxValObj) {
										maxVal = maxVal * maxValObj.koef;
										maxValUnit = maxValObj.unit || filter.unit;
									}
								}
								valueTextEl.innerText = minVal + minValUnit + ' ~ ' + maxVal + (maxValUnit ? ' ' + maxValUnit : '');
								
								rmBtn = document.createElement('button');
								rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
								rmBtn.type = 'button';
								rmBtn.className = 'px-2';
								rmBtn.setAttribute('data-filter', filter.oid);
								rmBtn.addEventListener('click', function () {
									let filter = self.filters[this.getAttribute('data-filter')];
									let filterOptions = self.getFilterOptions(filter);
									if(filterOptions.fnChange(filter.oid, null, null)){
										filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
										self.submit();
									}
								});
								valueWrapEl.appendChild(valueTextEl);
								valueWrapEl.appendChild(rmBtn);
								activeWrapEl.appendChild(valueWrapEl);
								activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
									label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
									clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
								}, {
									filter: filter,
									clearFilter: clearFilter
								})[0]);
								self.filters[filter.oid].active = true;
								return activeWrapEl;
							}
							return false;
						},
						fnChange: function (oid, min, max) {
							let changed = false,
								filterOptions = self.getFilterOptions(self.filters[oid]),
								filter = self.filters[oid];
								
							min = filterOptions.fnParseValue(min);
							max = filterOptions.fnParseValue(max);
							if (min === filter.initMinValue) min = null;
							if (max === filter.initMaxValue) max = null;
							if (filter.minValue === filter.initMinValue) {
								filter.minValue = null;
								filter.boundaryMinValue = null;
							}
							if (filter.maxValue === filter.initMaxValue) {
								filter.maxValue = null;
								filter.boundaryMaxValue = null;
							}
							if (filter.minValue != min && !(filter.minValue === null && min === filter.boundaryMinValue)) {
								filter.minValue = min;
								changed = true;
							}
							if (filter.maxValue != max && !(filter.maxValue === null && max === filter.boundaryMaxValue)) {
								filter.maxValue = max;
								changed = true;
							}
							return changed;
						},
						fnUpdate: function (filter) {
							let filterOptions = self.getFilterOptions(filter),
								_filter, filterMin, filterMax, i, j, valueCount;
								
							filter.values = filter.values.sort(filterOptions.fnSortValues);
							// Pokud hodnota n�hodou mezi p�vodn�mi filtry neexistuje (nap�. filtr se ji� na�etl zafiltrovan�), tak se p�id�
							if (!(self.filters.hasOwnProperty(filter.oid))) {
								self.filters[filter.oid] = filter;
							}
							_filter = self.filters[filter.oid];

							// Je n�kter� hodnota (a tedy i filtr jako takov�) aktivn�/selected?
							_filter.selected = (typeof _filter.minValue === 'number' || typeof _filter.maxValue === 'number');

							filterMin = null;
							filterMax = null;
							for (i = 0; i < _filter.values.length; i++) {
								valueCount = 0;
								if (!filter.disabled) {
									for (j = 0; j < filter.values.length; j++) {
										if (_filter.values[i].value == filter.values[j].value && _filter.values[i].value2 == filter.values[j].value2) {
											valueCount = filter.values[j].count;
											if (filterMin === null || filter.values[j].value < filterMin) {
												filterMin = filter.values[j].value;
											}
											if (filterMax === null || filter.values[j].value2 > filterMax) {
												filterMax = filter.values[j].value2;
											}
											if (!filter.values[j].value2 || filter.values[j].value > filterMax) {
												filterMax = filter.values[j].value;
											}
											break;
										}
									}
								}
							}

							// Nastaven� p�vodn� min/max hodnoty filtru
							if (!_filter.hasOwnProperty('initMinValue')) _filter.initMinValue = filterMin;
							if (!_filter.hasOwnProperty('initMaxValue')) _filter.initMaxValue = filterMax;

							if (!_filter.selected) {
								_filter.boundaryMinValue = filterMin;
								_filter.boundaryMaxValue = filterMax;
							} else {
								_filter.boundaryMinValue = _filter.initMinValue;
								_filter.boundaryMaxValue = _filter.initMaxValue;
							}

							if (false && _filter.selected && typeof _filter.minValue !== 'number') {
								_filter.minValue = (filterMin > _filter.boundaryMinValue ? filterMin : null);
							}
							if (false && _filter.selected && typeof _filter.maxValue !== 'number') {
								_filter.maxValue = (filterMax < _filter.boundaryMaxValue ? filterMax : null);
							}
						},
						fnStringify: function (filter) {
							return filter.oid + ':::' + filter.type + ':::' + (typeof filter.minValue === 'number' ? filter.minValue.toString().replace(/\./g, ',') : '') + '@@@' + (typeof filter.maxValue === 'number' ? filter.maxValue.toString().replace(/\./g, ',') : '') + '###';
						}
					}
				},
				fnGenerateActive: function (filter) {
					let filterOptions = self.getFilterOptions(filter),
						activeWrapEl = document.createElement('div'),
						i, valueWrapEl, valueTextEl, val1, val2, koef, unit, rmBtn;
					self.filters[filter.oid].active = false;

					for (i = 0; i < filter.values.length; i++) {
						if (filter.values[i].selected) {
							valueWrapEl = document.createElement('div');
							valueWrapEl.className = 'valueWrap';
							valueTextEl = document.createElement('span');
							val1 = filter.values[i][filterOptions.valueProperty];
							val2 = filter.values[i].value2;
							koef = filter.values[i].koef;
							unit = filter.values[i].unit || filter.unit;
							if (koef && !filterOptions.config._multiUnitActive) {
								val1 = val1*koef;
								if(val2) val2 = val2*koef;
								unit = filter.unit;
							}
							valueTextEl.innerText = (filter.values[i].hasOwnProperty('name') ? filter.values[i].name : val1)
								 + (val2 ? '~' + val2 : '')
								 + (unit && (val1 || typeof val1 === 'number') ? ' ' + unit : '')
								 + (filter.values[i].count && self.options.showQuantity ? ' (' + filter.values[i].count + ')' : '');
							valueWrapEl.appendChild(valueTextEl);
							rmBtn = document.createElement('button');
							rmBtn.innerHTML = '<i class="fas fa-fw fa-times"></i>';
							rmBtn.type = 'button';
							rmBtn.className = 'px-2';
							rmBtn.setAttribute('data-filter', filter.oid);
							rmBtn.setAttribute('data-value', filter.values[i][filterOptions.valueProperty]);
							rmBtn.addEventListener('click', function () {
								let filter = self.filters[this.getAttribute('data-filter')];
								let filterOptions = self.getFilterOptions(filter);
								if(filterOptions.fnChange(filter.oid, this.getAttribute('data-value'), false)){
									filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
									self.submit();
								}
							});
							valueWrapEl.appendChild(rmBtn);
							activeWrapEl.appendChild(valueWrapEl);
						}
					}
					if (activeWrapEl.children.length > 0) {
						activeWrapEl.firstChild.before(EBContext.utils.template('<!--#label-->', {
							label: '<div class="filterLabel"><!--#clearBtn--><!--$filter.name--></div>',
							clearBtn: '<button <!--!click@clearFilter--> class="text-danger" data-filter="<!--$filter.oid-->"><i class="fas fa-fw fa-trash"></i></button>'
						}, {
							filter: filter,
							clearFilter: clearFilter
						})[0]);					
						self.filters[filter.oid].active = true;
						return activeWrapEl;
					}
					return false;
				},
				fnSortValues: function (a, b) {
					let a_order = parseInt(a.order),
						b_order = parseInt(b.order);
					return ((a_order < b_order) ? -1 : ((a_order > b_order) ? 1 : ((a.value < b.value) ? -1 : ((a.value > b.value) ? 1 : 0))));
				},
				fnParseValue: function (value) {
					return value.toString().trim();
				},
				fnChange: function (oid, value, selected) {
					let changed = false,
						filterOptions = self.getFilterOptions(self.filters[oid]),
						i;
						
					value = filterOptions.fnParseValue(value);
					for (i = 0; i < self.filters[oid].values.length; i++) {
						if (self.filters[oid].values[i][filterOptions.valueProperty] == value) {
							if(self.filters[oid].values[i].selected !== selected) changed = true;
							self.filters[oid].values[i].selected = selected;
						}
					}
					return changed;
				},
				fnClear: function(oid) {
					let i;
					for (i = 0; i < self.filters[oid].values.length; i++) {
						self.filters[oid].values[i].selected = false;
					}
					self.filters[oid].minValue = null;
					self.filters[oid].maxValue = null;
					self.filters[oid].selected = false;
					return true;
				},
				fnUpdate: function (filter) {

					// Na�ten� funkc� dan�ho typu filtru
					let filterOptions = self.getFilterOptions(filter),
						_filter, i, j, valueCount, disabled;

					// Se�azen� hodnot (pro p��pad na�ten� nov�ch)
					filter.values = filter.values.sort(filterOptions.fnSortValues);

					// Pokud filtr dan� parametr je�t� nezn�, tak si ho ulo��
					if (!(self.filters.hasOwnProperty(filter.oid))) {
						self.filters[filter.oid] = filter;
					}
					_filter = self.filters[filter.oid];

					// Je n�kter� hodnota (a tedy i filtr jako takov�) aktivn�/selected?
					_filter.selected = false;
					for (i = 0; i < _filter.values.length; i++) {
						if (_filter.values[i].selected) {
							_filter.selected = true;
							break;
						}
					}

					// pro ka�dou hodnotu ulo�en�ho parametru filtru
					for (i = 0; i < _filter.values.length; i++) {
						valueCount = 0;
						disabled = !_filter.selected;

						if (_filter.type === 'BOOLEAN') {
							if (_filter.values[i].value == '0') {
								_filter.values[i].name = EBContext.resource('NE');
							}
							if (_filter.values[i].value == '1') {
								_filter.values[i].name = EBContext.resource('ANO');
							}
						}

						// pro enum naplnit vlastnost name - mo�nost do budoucna u typu COLOR jako name pos�lat i n�zev barvy
						if (filterOptions.valueProperty !== 'value') _filter.values[i].name = _filter.values[i].value;

						// Pokud se filtr na�etl, tak aktualizovat jeho hodnoty
						if (!filter.disabled) {

							// najdi odpov�daj�c� hodnotu
							for (j = 0; j < filter.values.length; j++) {
								if (_filter.values[i][filterOptions.valueProperty] == filter.values[j][filterOptions.valueProperty] && _filter.values[i].value2 == filter.values[j].value2) {

									// pokud je odpov�daj�c� hodnota nalezena, tak ji povolit
									disabled = false;
									valueCount = filter.values[j].count;
									break;
								}
							}
						}
						_filter.values[i].disabled = disabled;
						_filter.values[i].count = valueCount;
					}
				},
				fnStringify: function (filter) {
					let filterOptions = self.getFilterOptions(filter),
						values = '', i;
						
					for (i = 0; i < filter.values.length; i++) {
						if (filter.values[i].selected) {
							values += filter.values[i][filterOptions.valueProperty] + '@@@';
						}
					}
					return filter.oid + ':::' + filter.type + ':::' + values + '###';
				}
			},
			UNSUPPORTED: {
				valueProperty: 'value',
				fnGenerateFilterBody: function (filter, fnChange) {
					let filterWrap = document.createElement('div');
					filterWrap.innerText = EBContext.resource('USR_unknownFilterType').replace(/#TYPE#/g, filter.type);
					return filterWrap;
				},
				fnUpdateFilterValues: function (filter, scope) {
					return false;
				},
				fnGenerateActive: function (filter) {
					return false;
				},
				fnSortValues: function (a, b) {
					return ((a.value < b.value) ? -1 : ((a.value > b.value) ? 1 : 0));
				},
				fnParseValue: function (value) {
					return false;
				},
				fnChange: function (oid, value, selected) {
					return false;
				},
				fnClear: function(oid) {
					return true;
				},
				fnUpdate: function (filter) {
					return false;
				},
				fnStringify: function (filter) {
					return '';
				}
			}
		},
		filterTypesFallback: {},
		paramsMap: {
			'_cenaoddo': {
				filterTypeKod: 'SLIDER_INPUTS',
				filterTypeConfig: {
					type: 'double',
					grid: false,
					drag_interval: true,
					decorate_both: false,
					force_edges: true
				}
			},
			'_cenaoddo2': {
				filterTypeKod: 'SLIDER_INPUTS',
				filterTypeConfig: {
					type: 'double',
					grid: false,
					drag_interval: true,
					decorate_both: false,
					force_edges: true
				}
			}
		},
		fnSortFilters: function (a, b) {
			if(self.topParams.length){
				let at = (self.topParams.indexOf(a.oid) > -1);
				let bt = (self.topParams.indexOf(b.oid) > -1);
				if(at && !bt) return -1;
				if(!at && bt) return 1;
			}
			if(a.minPozice < b.minPozice) return -1;
			if(a.minPozice > b.minPozice) return 1;
			let nameA = a.name.toLowerCase();
			let nameB = b.name.toLowerCase();
			if(nameA < nameB) return -1;
			if(nameA > nameB) return 1;
			return 0;
		},
		fnGenerateFilterHead: function (filter) {
			let collapsible = (self.collapsibleParams && (filter.oid[0] !== '_' || self.options.filterRelocated));
			let headWrap = document.createElement(collapsible ? 'summary' : 'div'),
				headingEl = document.createElement('div'),
				rmWrap = document.createElement('div');
				
			let toggleEl = EBContext.utils.template('<span class="jsmenu-toggle me-2"><!--#iconOpened--><!--#iconClosed--></span>', {
				iconOpened: '<i class="fas fa-fw fa-chevron-down details_opened"></i>',
                iconClosed: '<i class="fas fa-fw fa-chevron-right details_closed"></i>'
			});
				
			headWrap.id = 'filter_' + filter.oid + '_head';
			headWrap.className = 'd-flex align-items-center mb-2' + (collapsible && !self.options.filterRelocated ? ' px-2' : '');

			headingEl.className = 'd-flex';
			headingEl.innerText = filter.name;
			
			rmWrap.className = 'd-flex filter_rmWrap flex-grow-1 justify-content-end';
			rmWrap.id = 'filter_' + filter.oid + '_rmWrap';
			
			if(collapsible) headWrap.appendChild(toggleEl[0]);
			headWrap.appendChild(headingEl);
			headWrap.appendChild(rmWrap);
			
			return headWrap;
		},
		fnUpdateFilterHead: function(filter){
			let rmWrap = document.getElementById('filter_' + filter.oid + '_rmWrap'),
				filterOptions, clearBtn;
				
			if(rmWrap){
				if(filter.selected){
					if(!document.getElementById('filter_' + filter.oid + '_clear')){
						filterOptions = self.getFilterOptions(filter);
						clearBtn = document.createElement('button');
						clearBtn.type = 'button';
						clearBtn.className = 'filter_clear btn btn-sm btn-danger';
						clearBtn.id = 'filter_' + filter.oid + '_clear';
						clearBtn.innerText = EBContext.resource('NEFILTROVAT');
						clearBtn.setAttribute('data-filter', filter.oid);
						clearBtn.addEventListener('click', function () {clearFilter(null,this)});
						rmWrap.appendChild(clearBtn);
					}
				}
				else{
					rmWrap.innerHTML = '';
				}
			}
		},
		fnGenerateFilters: function (filters, fnGenerateFilterHead, fnGenerateFilterBody) {
			let resultEl = document.createElement('div'),
				topEl = document.createElement('div'), 
				othersEl, btnShowAll, i, filterBody;
				topEl.className = 'box-visible';
				resultEl.id = 'filtersWrap';
			if(!self.showOtherParams){
				btnShowAll = EBContext.utils.template('<button type="button" class="show-more btn btn-primary mb-3 w-100"><!--~resource.ZOBRAZIT_PARAMETRY--></button>')[0];
				btnShowAll.setAttribute('data-togglemore', "{textMore:EBContext.resource('ZOBRAZIT_DALSI_FILTRY'),textLess:EBContext.resource('SKRYT_DALSI_FILTRY')}");
				othersEl = EBContext.utils.template('<div class="box-more"></div>')[0];
			}
			for (i = 0; i < filters.length; i++) {
				filterBody = document.createElement('div');
				filterBody.id = 'filter_' + filters[i].oid + '_body';
				filterBody.className = 'pb-3';
				filterBody.appendChild(fnGenerateFilterBody(filters[i]));
				let collapsible = (self.collapsibleParams && (filters[i].oid[0] !== '_' || self.options.filterRelocated));
				let filterWrap = document.createElement((collapsible ? 'details' : 'div'));
				filterWrap.appendChild(fnGenerateFilterHead(filters[i]));
				filterWrap.appendChild(filterBody);
				if(self.topParams.indexOf(filters[i].oid) > -1 || filters[i].topParam || filters[i].selected || self.showOtherParams){
					topEl.appendChild(filterWrap);
					if(self.topParams.indexOf(filters[i].oid) > -1 || filters[i].topParam || filters[i].selected || self.expandOtherParams) filterWrap.setAttribute('open', '');
				} else {
					othersEl.appendChild(filterWrap);
				}
			}
			resultEl.appendChild(topEl);
			if(!self.showOtherParams && othersEl.childElementCount){
				resultEl.appendChild(btnShowAll);
				resultEl.appendChild(othersEl);
				prepareToggleMore(btnShowAll);
			}
			return resultEl;
		},
		fnGenerateActive: function (filters, wrapEl) {
			let filterOptions, activeFilterEl, i;
			wrapEl = wrapEl || self.activeWrapEl;
			while (wrapEl.firstChild) wrapEl.removeChild(wrapEl.firstChild);
			for (i = 0; i < filters.length; i++) {
				filterOptions = self.getFilterOptions(filters[i]);
				activeFilterEl = filterOptions.fnGenerateActive(filters[i]);
				if (activeFilterEl) wrapEl.appendChild(activeFilterEl);
			}
			if(wrapEl.children.length){
				wrapEl.append(EBContext.utils.template('<div class="mt-2 me-0 d-flex justify-content-end"><!--#btnRmAll--></div>', {
					btnRmAll: '<button type="button" class="btn btn-sm btn-danger" <!--!click@rmAll--> ><!--~resource.VYMAZAT_FILTRY_PARAMETRU--></button>'
				}, {
					rmAll: (e,el,vars,params)=>{
						filters.forEach(filter=>{
							let filterOptions = self.getFilterOptions(filter);
							filterOptions.fnClear(filter.oid);
							filterOptions.fnUpdateFilterValues(filter,self.filterWrapEl);
						});
						self.submit();
					}
				})[0]);
			}
		},
		fnToggleFilter: function (open) {
			self.filterWrapEl.style.display = (open ? '' : 'none');
		}
	}, options);

	//cache vygenerovan�ch options pro pou�it� kombinace filter.type a filter.filterTypeKod
	this.optionsCache = {};
	self.loader = self.options.getLoader(self.filterWrapEl);

	this.getValId = function(oid, value){
		return 'filter_' + oid + '_' + value.toString().replace(/[\.,#]/g, '_');
	};

	// Declare/Reset instance-specific data to initial values to prepare parametric filter to load a new set of filters (e.g. for different category)
	this.reset = function () {
		// console.debug('%cParametric filter - reset','color:white;background:black;padding:.5em;border:2px solid red');
		this.isRendered = false;		// Je vyrenderov�no HTML?
		this.isUpdated = false;			// Na�ten� filtry jsou aktu�ln�?
		this.isOpen = false;			// Filtr je otev�en�?
		this.activeWrapEl = null;		// Reference na DOM element obaluj�c� aktivn� seznam vyfiltrovan�ch hodnot. Po reloadu str�nky se mus� setnout znovu.
		this.filterWrapEl = null;		// Reference na DOM element obaluj�c� seznam filtr�. Po reloadu str�nky se mus� setnout znovu.
		this.priceWrapEl = null;		// Reference na DOM element obaluj�c� filtr ceny. Po reloadu str�nky se mus� setnout znovu.
		this.extendedFilterEl = null;	// Reference na DOM element obaluj�c� roz���en� filtr (sklad. dostupnost, v�robci, dodavatel�, akce, atp.). Po reloadu str�nky se mus� setnout znovu.
		this.priceParam = '';			// Filtrovat dle ceny s DPH nebo bez? - "_cenaoddo" vs. "_cenaoddo2"
		this.goodResult = '';			// Seznam OID vyfiltrovan�ch produkt� k na�ten� relevantn�ch filtr�
		this.filterStr = '';			// String hodnot odeslan�ho filtru
		this.resultParams = {};			// Na��t� se z "EBContext.currentPage.pageData.params", a obsahuje parametry se kter�mi se na str�nce pracuje
		this.filters = {};				// Objekt filtr�
		this.sliders = {};			
		this.selects = {};
		this.filterStylesEl = null;
		this.filterStyles = {};
	};
	
	// Reset selected params values
	this.clear = function (){
		// console.debug('%cParametric filter - clear','color:white;background:black;padding:.5em;border:2px solid red');
		let filtersKeys = Object.keys(self.filters),
			filter, filterOptions, i;
		for (i = 0; i < filtersKeys.length; i++) {
			filter = self.filters[filtersKeys[i]];
			filterOptions = self.getFilterOptions(filter);
			filterOptions.fnClear(filter.oid);
		}
		return self.submit();
	};

	// Returns combination of filter options based on default filter and extended with options for filter.type and filter.filterTypeKod
	this.getFilterOptions = function (filter) {

		// skip this parameteter - render it as unsupported - foolproof solution. If removed, filter will try to return absolute default options
		if (!self.options.useDefault && !self.options.paramsTypes.hasOwnProperty(filter.type)) {
			return self.options.paramsTypes.UNSUPPORTED;
		}
		
		// extend system filters with custom options
		if(self.options.paramsMap.hasOwnProperty(filter.oid)) EBContext.utils.extendObj(false, self.options.paramsMap[filter.oid], filter);

		// if filterType is not set, try to set it to default filterType for this paramType, else set it to default filterType of default paramType
		filter.filterTypeKod = filter.filterTypeKod || self.options.paramsTypes[filter.type].defaultFilterType || self.options.paramsTypes.DEFAULT.defaultFilterType;

		let filterOptions;
		// if options for combination of this param type and filter type has already been generated, return cached options
		if (self.optionsCache.hasOwnProperty(filter.type + ':' + filter.filterTypeKod)) {
			filterOptions = self.optionsCache[filter.type + ':' + filter.filterTypeKod];
		} else {
			filterOptions = EBContext.utils.mergeObj(
				false,
				self.options.paramsTypes.DEFAULT, // DEFAULT param
				EBContext.utils.searchObj(self.options.paramsTypes.DEFAULT, ['filterTypes', filter.filterTypeKod]), // specified or DEFAULT type
				self.options.paramsTypes[filter.type], // specified param
				EBContext.utils.searchObj(self.options.paramsTypes, [filter.type, 'filterTypes', filter.filterTypeKod]) // specified type of specified param
			);

			// There is no use for another filterTypes and defaultFilterType within options for one specific filterType
			delete filterOptions.filterTypes;
			delete filterOptions.defaultFilterType;

			// save merged settings to optionsCache
			self.optionsCache[filter.type + ':' + filter.filterTypeKod] = filterOptions;
		}
		if (filter.filterTypeConfig) {
			filterOptions.config = EBContext.utils.extendObj(false, {}, filterOptions.config, filter.filterTypeConfig);
		}
		return filterOptions;
	};

	// Sets local references to DOM wrapping elements and restore filter state
	this.init = function (options) {
		EBContext.utils.extendObj(false, self.options, options);
		console.debug('%c - inicializace param. filtru (po require EBContext_ParametricFilter)', 'background:red;color:white;padding:1em 2em', self);
		let postData = window.history.state.postData,
			savedElements = window.history.state.savedElements,
			filterData = EBContext.utils.searchObj(window.history.state, ['pageData', 'paramFilter']),
			submitExFormEl, jenSkladEl, submitForm = ()=>submitExFormEl.click();
		
		// Pokud se z body ztrat� element filtru a nejsou odeslan� postData, tak filtr resetovat 
		if (!document.body.contains(self.filterWrapEl) && !postData) {
			self.reset();
		// jinak obnovit stav input� roz���en�ho filtru
		} else if(savedElements){
			EBContext.ajaxNav.setElementsState(savedElements);
		}
		self.category = self.options.category || null;
		self.topParams = [];
		self.showParamFilter = true;
		self.showOtherParams = true;
		self.collapsibleParams = true; //false;
		if(self.category){
			let catObj = EBContext.jsMenu.getCatObj(EBContext.jsMenu.getCatID(null, self.options.category)); // @TODO - require jsmenu!
			self.showParamFilter = catObj.ShowParamFilter;
			if(catObj.TopParameters) self.topParams = catObj.TopParameters.split(',');
			self.showOtherParams = (catObj.ShowOtherParams!==1); // 0 - zobrazit, 1 - nezobrazovat, 2 = zobrazit sbalen� (Glob�ln� ��seln�k "Good_Category.ShowOtherParams")
			//self.collapsibleParams = (catObj.ShowOtherParams===2);
			self.expandOtherParams = (catObj.ShowOtherParams===0);
		}
		self.priceParam = (self.options.priceWithVAT ? '_cenaoddo' : '_cenaoddo2');
		self.priceWrapEl = document.getElementById(self.options.priceWrapId);
		self.filterWrapEl = document.getElementById(self.options.filterWrapId);
		self.activeWrapEl = document.getElementById(self.options.activeWrapId);
		self.extendedFilterEl = document.getElementById(self.options.extendedFilterId);
		self.resultParams = EBContext.utils.searchObj(EBContext, ['currentPage','pageData','params']);
		// self.loader = self.options.getLoader(self.filterWrapEl);
		self.filterStr = self.resultParams.paramFilter;
		
		self.filterStylesEl = self.filterStylesEl || document.getElementById(self.options.filterWrapId + '_styles');
		if(!self.filterStylesEl || !document.body.contains(self.filterStylesEl)){
			self.filterStylesEl = document.createElement('style');
			self.filterStylesEl.id = self.options.filterWrapId + '_styles';
			if(self.filterWrapEl) self.filterWrapEl.before(self.filterStylesEl);
		}
		
		//pokud jsou v objektu historie ulo�ena data param. filtru, tak je na��st 
		if (filterData) {
			
			//na��st ulo�en� stav param. filtr�
			if(filterData.filters) self.filters = filterData.filters;
			
			//obnovit stav filtru
			self.isOpen = filterData.open;
			
			//pokud nebyl vr�cen� paramFiltr v resultParams, ale dle history objektu bylo n�co filtrov�no, tak odeslat filtr (reload okna)
			if(filterData.filterStr && filterData.filterStr !== self.filterStr){
				self.filterStr = filterData.filterStr;
				self.isRendered = false;
				return self.submit(true);
			}
		}
		
		submitExFormEl = self.extendedFilterEl.querySelector('input[type="submit"]');
		if(!submitExFormEl){
			submitExFormEl = document.createElement('input');
			submitExFormEl.type = 'submit';
			submitExFormEl.style.visibility = 'hidden';
			submitExFormEl.style.height = '0px';
			self.extendedFilterEl.appendChild(submitExFormEl);
		}
		[self.filterWrapEl, self.priceWrapEl, self.extendedFilterEl].forEach(el=>{
			el.addEventListener('keydown', e=>{
				if(e.key === 'Enter'){
					document.activeElement.blur();
					// submitForm();
				}
			});
		});
		[...self.extendedFilterEl.querySelectorAll('input[name]')].forEach(el=>el.onchange = submitForm);
		jenSkladEl = document.getElementById('jenskladSelect');
		if(jenSkladEl) jenSkladEl.onchange = evt=>{
			let jensklad, provozovna, maloobchod, 
				el = evt.target;
			if(el.value === 'true'){
				jensklad = '1';
				provozovna = '';
				maloobchod = '';
			}
			else if(el.value === 'false'){
				jensklad = '';
				provozovna = '';
				maloobchod = '';
			}
			else{
				jensklad = '1';
				provozovna = el.value;
				maloobchod= '';
			}
			self.extendedFilterEl.querySelector('input[name="jensklad"]').value = jensklad;
			self.extendedFilterEl.querySelector('input[name="maloobchod"]').value = maloobchod;
			self.extendedFilterEl.querySelector('input[name="provozovna"]').value = provozovna;
			submitForm();
		};
		
		self.extendedFilterEl.setAttribute('initialized', true);
		
		if(self.isOpen || self.options.alwaysOpen){
			self.toggle(true);
		}
		EBContext.async.finish('paramFilter-submit');
		document.addEventListener('EBContext.session.setCurrency', ()=>{
			// @TODO - upravit tak, aby se hodnoty p�epo��taly kurzem, a nemusely se resetovat
			// debugger;
			// let kkoef = EBContext.data.session.Cust_Kurz / EBContext.data.session.Cust_KurzPocet;
			// let priceFilter = self.filters[self.priceParam];
			// ['boundaryMaxValue','boundaryMinValue','initMaxValue','initMinValue'].forEach(prop=>{
			// 	priceFilter[prop] = priceFilter[prop] * priceFilter.koef / kkoef;
			// });
			// priceFilter.values.forEach(val=>{
			// 	['value','value2'].forEach(prop=>{
			// 		val[prop] = val[prop] * priceFilter.koef / kkoef;
			// 	});
			// });
			delete self.filters[self.priceParam];
			self.isRendered = false;
			self.isUpdated = false;
			// self.isOpen = false;
			self.filterStr = self.stringify();
			self.store(true);
		});
	};
	
	// If paramFilter is collapsible, this is to be toggling it's visibility
	this.toggle = function (open) {
		// console.debug('%cParametric filter - toggle','color:white;background:black;padding:.5em;border:2px solid red');
		
		// Pokud nen� p�edan� po�adovan� stav, oto�it aktu�ln� stav
		self.isOpen = (typeof open !== 'undefined' ? open : !self.isOpen);
		
		let hasParams = (Object.keys(self.filters).find(k=>(k[0]!=='_')));
		
		// Pokud m� b�t filtr otev�en�, ale nen� vyrenderovan�, tak vyrenderovat
		if (self.isOpen && (!self.isRendered || !self.isUpdated)){
			self.render();
		} else if(self.isOpen && hasParams){
			self.filterWrapEl.style.display = '';
		}
		
		// Otev��t/Zav��t filtr v DOM
		self.options.fnToggleFilter(self.isOpen);

		// Ulo�it stav filtru pro p��pad p�ena�ten�
		self.store();
		return self.isOpen;
	};
	
	// render DOM elements of filters, according to filters object and options for each filter.type and filter.filterTypeKod
	this.render = function () {
		if(!self.isUpdated){
			return self.update(self.options.parameters);
		} else {
			if(!self.showParamFilter){
				if(self.filterWrapEl) self.filterWrapEl.innerHTML = '';
				return;
			}
			let i, filter, filterOptions, resultEl,
				filtersArr = [],
				filtersKeys = Object.keys(self.filters);
				
			for (i = 0; i < filtersKeys.length; i++) {
				if (filtersKeys[i][0] !== '_') {
					filtersArr.push(self.filters[filtersKeys[i]]);
				}
			}
			filtersArr.sort(self.options.fnSortFilters);
			if (self.isRendered) {
				for (i = 0; i < filtersArr.length; i++) {
					filterOptions = self.getFilterOptions(filtersArr[i]);
					filterOptions.fnUpdateFilterValues(filtersArr[i]);
					self.options.fnUpdateFilterHead(filtersArr[i]);
				}
				if (self.priceWrapEl && self.filters.hasOwnProperty(self.priceParam)) {
					filter = self.filters[self.priceParam];
					filterOptions = self.getFilterOptions(filter);
					filterOptions.fnUpdateFilterValues(filter, self.priceWrapEl);
				}
			} else {
				self.filterWrapEl.innerHTML = '';
				resultEl = self.options.fnGenerateFilters(filtersArr, self.options.fnGenerateFilterHead, function (filter) {
					filterOptions = self.getFilterOptions(filter);
					self.options.fnUpdateFilterHead(filter);
					return filterOptions.fnGenerateFilterBody(filter, filterOptions.fnChange);
				});
				self.filterWrapEl.appendChild(resultEl);
				
				if (self.priceWrapEl && self.filters.hasOwnProperty(self.priceParam)) {
					filter = self.filters[self.priceParam];
					filter.topParam = true;
					let tmp_filterWrap = self.options.fnGenerateFilters([filter], self.options.fnGenerateFilterHead, function (filter) {
						filterOptions = self.getFilterOptions(filter);
						self.options.fnUpdateFilterHead(filter);
						return filterOptions.fnGenerateFilterBody(filter, filterOptions.fnChange);
					});
					while (self.priceWrapEl.firstChild) self.priceWrapEl.removeChild(self.priceWrapEl.firstChild);
					while (tmp_filterWrap.firstChild) self.priceWrapEl.appendChild(tmp_filterWrap.firstChild);
				}
	
				EBContext.ajaxNav.ready(self.initPlugins);
				self.isRendered = true;
				
			}
			if(filtersArr.length > 0) self.filterWrapEl.style.display = '';
			
			let sheet = self.filterStylesEl.sheet;
			while(sheet && sheet.rules && sheet.rules.length) sheet.deleteRule(0);
			Object.entries(self.filterStyles).forEach(fs=>fs[1].forEach(fc=>{
				let mainSel = '#'+self.filterWrapEl.parentElement.id+' .'+fs[0]+' ';
				let sArr = fc.split('{');
				let selectors = mainSel+sArr[0].split(',').join(','+mainSel);
				let rules = sArr[1].trim();
				if(rules.charAt(rules.length-1)==='}') rules = rules.slice(0,-1);
				sheet.addRule(selectors, rules);
			}));
			
			if(self.filters[self.priceParam]) filtersArr.push(self.filters[self.priceParam]);
			self.options.fnGenerateActive(filtersArr);
			self.store();
			if('function' === typeof prepareToggleMore) [...self.filterWrapEl.querySelectorAll('button.show-more')].forEach(el=>prepareToggleMore(el));
		}
		EBContext.async.finish('paramFilter-submit');
	};

	// Updates the filters object according to new filterData, then calls render()
	this.update = function (filterData) {
		delete self.options.parameters;
		if(!filterData) return self.fetch();
		console.debug('%c - aktualizovat hodnoty param. filtru', 'background:red;color:white;padding:1em 2em');
		let i, j, filter, filterOptions, multiUnit, multiUnitFallback, tmp, filtersKeys, 
			dataKeys = Object.keys(filterData);
			
		for (i = 0; i < dataKeys.length; i++) {
			filter = filterData[dataKeys[i]];

			filter.disabled = false;
			if (filter.filterTypeConfig && typeof filter.filterTypeConfig !== 'object') {
				try {
					filter.filterTypeConfig = JSON.parse(filter.filterTypeConfig);
				} catch (e) {
					filter.filterTypeConfig = {};
					console.error('Error parsing filterTypeConfig: ', e);
				}
			} else { filter.filterTypeConfig = {}; }
			multiUnit = ([...new Set(filter.values.map(val => val.unit))].length > 1);
			multiUnitFallback = self.options.filterTypesFallback[filter.filterTypeKod];
			if(multiUnit && multiUnitFallback) filter.filterTypeKod = multiUnitFallback;
			
			if(filter.oid===self.priceParam){
				filter.koef = EBContext.data.session.Cust_Kurz / EBContext.data.session.Cust_KurzPocet
			}
			
			filterOptions = self.getFilterOptions(filter);
			for (j = 0; j < filter.values.length; j++) {
				filter.values[j].value = filterOptions.fnParseValue(filter.values[j].value);
				if(filter.type === 'RANGE' && typeof filter.values[j].value2 === 'number' && filter.values[j].value2 < filter.values[j].value){
					tmp = filter.values[j].value;
					filter.values[j].value = filter.values[j].value2;
					filter.values[j].value2 = tmp;
				}
			}
			if (!(self.filters.hasOwnProperty(filter.oid))) {
				filterOptions.fnUpdate(filter);
			}
		}

		filtersKeys = Object.keys(self.filters);
		for (i = 0; i < filtersKeys.length; i++) {
			filter = self.filters[filtersKeys[i]];
			filter.disabled = (dataKeys.indexOf(filtersKeys[i]) < 0);
			filterOptions = self.getFilterOptions(filter);
			filterOptions.fnUpdate(filterData[filtersKeys[i]] || filter);
		}
		EBContext.ajaxNav.createElementsState(self.filterWrapEl.parentElement);
		self.isUpdated = true;
		self.render();
	};

	// Retrieve filters data from server according to actual products OID list (goodResult)
	this.fetch = function (dataCallback) {
		// console.debug('%cParametric filter - fetch','color:white;background:black;padding:.5em;border:2px solid red');
		let goodResult = self.resultParams.goodResult || '';
		console.log('%cNa�ten� parametr� a hodnot filtru pro produkty: %O', 'background: LightGreen', goodResult.split(';'));
		
		EBContext.async.start('paramFilter-fetch');
		EBContext.ajaxNav.ajaxCall('/update.asp?ebPageItemCall=' + self.options.resultBlockName + '&ebPageItemMethod=getParameterFiltr&skipHead=1&path=' + self.options.resultPagePath, function (response) {
			let filterData = {};
			try {
				if (typeof response === 'string') response = response.replace(/"selected"\s*:\s*"false"/gi, '"selected":false').replace(/"selected"\s*:\s*"true"/gi, '"selected":true');
				filterData = JSON.parse(response);
			} catch (err) {
				console.error('%cError parsing fetched JSON!', EBContext.options.consoleStyles.errorMsg);
				console.groupCollapsed('%cJS error', EBContext.options.consoleStyles.errorBtn);
				console.error(err);
				console.groupEnd();
				console.groupCollapsed('%cShow code', EBContext.options.consoleStyles.errorBtn);
				console.error('%c' + response, EBContext.options.consoleStyles.code);
				console.groupEnd();
			}
			if('function' === typeof dataCallback) filterData = dataCallback(filterData);
			self.update(filterData);
			EBContext.async.finish('paramFilter-fetch');
		}, 'GoodResult=' + goodResult, {loader: self.loader});
	};

	//initializes all JS plugins (search-selects, sliders, etc...)
	this.initPlugins = function () {
		require(['jquery', 'bootstrap-select'], (jQuery)=>{
			let keys, i;
			keys = Object.keys(self.selects);
			for (i = 0; i < keys.length; i++) {
				jQuery('#' + self.selects[keys[i]].elementId).selectpicker(self.selects[keys[i]].options);
			}
		});
		require(['jquery', 'ion-rangeslider'], (jQuery)=>{
			let keys, i, sliderEl;
			keys = Object.keys(self.sliders);
			for (i = 0; i < keys.length; i++) {
				sliderEl = jQuery('#' + self.sliders[keys[i]].elementId);
				sliderEl.ionRangeSlider(self.sliders[keys[i]].options);
				self.sliders[keys[i]].instanceObj = sliderEl.data('ionRangeSlider');
			}
		});
	};

	// returns filters string to be send in postData
	this.stringify = function () {
		let stringifiedFilters = [],
			filtersKeys = Object.keys(self.filters),
			filter, filterOptions, i;

		for (i = 0; i < filtersKeys.length; i++) {
			filter = self.filters[filtersKeys[i]];
			filterOptions = self.getFilterOptions(filter);
			stringifiedFilters.push(filterOptions.fnStringify(filter));
		}
		return stringifiedFilters.join('');
	};

	// saves filter data to history object
	this.store = function (override) {
		let updateObj = {
			filters: self.filters,
			open: self.isOpen,
			filterStr: self.filterStr,
			category: self.category
		};
		if(override){
			EBContext.utils.setObj(EBContext, ["ajaxNav", "currentState", "pageData", "paramFilter"], updateObj);
		} else {
			// console.debug('%cParametric filter - store','color:white;background:black;padding:.5em;border:2px solid red');
			EBContext.utils.extendObj(false, EBContext.ajaxNav.currentState, {
				pageData: {
					paramFilter: updateObj
				},
				processPostData: 0
			});
		}
		EBContext.ajaxNav.saveState();
	};

	//submits parametric filter
	this.submit = function (reload, url) {
		console.debug('%c - odeslat param. filtr (i s hodnotami ext. filtru)', 'background:red;color:white;padding:1em 2em');
		reload = reload || false;
		EBContext.async.start('paramFilter-submit');
		let urlParams = {}, postParams = {}, 
			form = document.getElementById(self.options.extendedFilterId);

		if (window.history.state.postData){
			postParams = EBContext.utils.paramsStrToObj(window.history.state.postData, true);
		}
		if (!reload){
			if (form){
				if(form.method && form.method.toString().toLowerCase() === 'post'){
					postParams = EBContext.utils.extendObj( postParams, EBContext.utils.serializeForm(form, true) );
				} else {
					urlParams = EBContext.utils.serializeForm(form, true);
				}
				EBContext.ajaxNav.createElementsState(self.filterWrapEl.parentElement);
			}
			urlParams.page = '1';
			self.isUpdated = false;
		}
		self.filterStr = self.stringify();
		postParams.params = self.filterStr;
		self.store();
		url = EBContext.utils.extendURL(url, urlParams);
		EBContext.ajaxNav.currentState.postData = EBContext.utils.paramsObjToStr(postParams);
		EBContext.ajaxNav.saveState();
		EBContext.ajaxNav.navigationTrigger(url, EBContext.utils.createAjaxURL(url, {
			reload: self.options.reloadBlock
		}), postParams, {
			navigation: false,
			scrollTop: '',
			updateURL: true
		});
		return true;
	};
	
	this.reset();
	return this;
};